import * as i1 from '@angular/cdk/platform';
import { PlatformModule } from '@angular/cdk/platform';
import * as i0 from '@angular/core';
import { InjectionToken, Optional, Inject, Injectable, LOCALE_ID, SkipSelf, NgModule, forwardRef, input, model, EventEmitter, effect, Output, Input, Directive, signal, viewChild, computed, afterRender, booleanAttribute, ChangeDetectionStrategy, Component, inject, Injector, afterNextRender, ViewChildren, ViewChild, ContentChild } from '@angular/core';
import { Subject, merge, Subscription, of } from 'rxjs';
import { DOWN_ARROW, SPACE, ENTER, PAGE_DOWN, PAGE_UP, END, HOME, UP_ARROW, RIGHT_ARROW, LEFT_ARROW, ESCAPE } from '@angular/cdk/keycodes';
import { CommonModule, NgClass, DOCUMENT } from '@angular/common';
import * as i5 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, Validators, NgControl, FormsModule } from '@angular/forms';
import * as i2 from '@aposin/ng-aquila/formfield';
import { NxFormfieldControl } from '@aposin/ng-aquila/formfield';
import { NxAbstractControl } from '@aposin/ng-aquila/shared';
import { getFontShorthand } from '@aposin/ng-aquila/utils';
import { takeUntil, filter } from 'rxjs/operators';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import { NX_INPUT_VALUE_ACCESSOR } from '@aposin/ng-aquila/input';
import * as i1$1 from '@angular/cdk/a11y';
import { CdkMonitorFocus, CdkTrapFocus, A11yModule } from '@angular/cdk/a11y';
import * as i5$1 from '@angular/cdk/overlay';
import { Overlay, OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import * as i3 from '@aposin/ng-aquila/icon';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import * as i6 from '@aposin/ng-aquila/button';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import * as i2$1 from '@angular/cdk/bidi';
import { ComponentPortal } from '@angular/cdk/portal';

/** Base class for all adapter implementations */
const _c0 = ["startDateFieldDirective"];
const _c1 = ["endDateFieldDirective"];
const _c2 = ["cell"];
const _c3 = ["nx-calendar-body", ""];
const _c4 = () => [];
const _forTrack0 = ($index, $item) => $item[0].value;
function NxCalendarBodyComponent_For_1_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 3);
  }
}
function NxCalendarBodyComponent_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NxCalendarBodyComponent_For_1_Conditional_1_For_1_Template, 1, 0, "td", 3, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(0, _c4).constructor(ctx_r0.previousItems));
  }
}
function NxCalendarBodyComponent_For_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 4)(1, "div", 5, 0);
    i0.ɵɵlistener("click", function NxCalendarBodyComponent_For_1_For_3_Template_div_click_1_listener() {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._cellClicked(item_r3));
    })("focus", function NxCalendarBodyComponent_For_1_For_3_Template_div_focus_1_listener() {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._cellFocused(item_r3));
    })("mouseover", function NxCalendarBodyComponent_For_1_For_3_Template_div_mouseover_1_listener() {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._cellFocused(item_r3));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ɵ$index_8_r4 = ctx.$index;
    const ctx_r4 = i0.ɵɵnextContext();
    const row_r6 = ctx_r4.$implicit;
    const ɵ$index_1_r7 = ctx_r4.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", 100 / ctx_r0.numCols, "%");
    i0.ɵɵclassProp("range-start", ctx_r0.selectedValue === item_r3.value && (ctx_r0.betweenRange().length > 0 || ctx_r0.selectedEndDate() === item_r3.value + 1))("range-end", ctx_r0.selectedEndDate() === item_r3.value && (ctx_r0.betweenRange().length > 0 || ctx_r0.selectedValue === item_r3.value - 1))("in-range", ctx_r0.selectedValue !== item_r3.value && ctx_r0.selectedEndDate() !== item_r3.value && ctx_r0.betweenRange().includes(item_r3.value))("range-row-start", ɵ$index_8_r4 === 0 && ctx_r0.betweenRange().includes(item_r3.value))("range-row-end", (ɵ$index_8_r4 === ctx_r0.numCols - 1 || ɵ$index_8_r4 === row_r6.length - 1) && ctx_r0.betweenRange().includes(item_r3.value));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("nx-calendar-body-disabled", !item_r3.enabled)("nx-calendar-body-active", ctx_r0._isActiveCell(ɵ$index_1_r7, ɵ$index_8_r4))("nx-calendar-body-selected", ctx_r0.selectedValue === item_r3.value || ctx_r0.selectedEndDate() === item_r3.value)("nx-calendar-body-today", ctx_r0.todayValue === item_r3.value);
    i0.ɵɵproperty("tabindex", ctx_r0._isActiveCell(ɵ$index_1_r7, ɵ$index_8_r4) ? 0 : -1);
    i0.ɵɵattribute("aria-label", item_r3.ariaLabel)("aria-disabled", !item_r3.enabled || null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r3.displayValue, " ");
  }
}
function NxCalendarBodyComponent_For_1_Conditional_4_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 3);
  }
}
function NxCalendarBodyComponent_For_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NxCalendarBodyComponent_For_1_Conditional_4_For_1_Template, 1, 0, "td", 3, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(0, _c4).constructor(ctx_r0.followingItems));
  }
}
function NxCalendarBodyComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 1);
    i0.ɵɵtemplate(1, NxCalendarBodyComponent_For_1_Conditional_1_Template, 2, 1);
    i0.ɵɵrepeaterCreate(2, NxCalendarBodyComponent_For_1_For_3_Template, 4, 24, "td", 2, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(4, NxCalendarBodyComponent_For_1_Conditional_4_Template, 2, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r6 = ctx.$implicit;
    const ɵ$index_1_r7 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_1_r7 === 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(row_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ɵ$index_1_r7 === ctx_r0._lastRowIndex && ctx_r0._lastRowOffset ? 4 : -1);
  }
}
function NxMonthViewComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r1 = ctx.$implicit;
    i0.ɵɵattribute("aria-label", day_r1.long);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(day_r1.narrow);
  }
}
const _c5 = ["previousButton"];
const _c6 = ["nextButton"];
const _c7 = ["changeViewButton"];
const _c8 = ["todayButton"];
function NxCalendarComponent_Case_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nx-month-view", 16);
    i0.ɵɵtwoWayListener("activeDateChange", function NxCalendarComponent_Case_15_Template_nx_month_view_activeDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2._activeDate, $event) || (ctx_r2._activeDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("hoverDateChange", function NxCalendarComponent_Case_15_Template_nx_month_view_hoverDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._hoverDateChange($event));
    })("selectedChange", function NxCalendarComponent_Case_15_Template_nx_month_view_selectedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._dateSelected($event));
    })("_userSelection", function NxCalendarComponent_Case_15_Template_nx_month_view__userSelection_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._userSelected());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isRange", ctx_r2.isRange());
    i0.ɵɵtwoWayProperty("activeDate", ctx_r2._activeDate);
    i0.ɵɵproperty("selected", ctx_r2._selected())("dateFilter", ctx_r2.dateFilter)("maxDate", ctx_r2.maxDate)("minDate", ctx_r2.minDate);
  }
}
function NxCalendarComponent_Case_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nx-year-view", 17);
    i0.ɵɵtwoWayListener("activeDateChange", function NxCalendarComponent_Case_16_Template_nx_year_view_activeDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2._activeDate, $event) || (ctx_r2._activeDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("monthSelected", function NxCalendarComponent_Case_16_Template_nx_year_view_monthSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._monthSelectedInYearView($event));
    })("selectedChange", function NxCalendarComponent_Case_16_Template_nx_year_view_selectedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._goToDateInView($event, "month"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isRange", ctx_r2.isRange());
    i0.ɵɵtwoWayProperty("activeDate", ctx_r2._activeDate);
    i0.ɵɵproperty("selected", ctx_r2.selected)("dateFilter", ctx_r2.dateFilter)("maxDate", ctx_r2.maxDate)("minDate", ctx_r2.minDate);
  }
}
function NxCalendarComponent_Case_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "nx-multi-year-view", 18);
    i0.ɵɵtwoWayListener("activeDateChange", function NxCalendarComponent_Case_17_Template_nx_multi_year_view_activeDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2._activeDate, $event) || (ctx_r2._activeDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("yearSelected", function NxCalendarComponent_Case_17_Template_nx_multi_year_view_yearSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._yearSelectedInMultiYearView($event));
    })("selectedChange", function NxCalendarComponent_Case_17_Template_nx_multi_year_view_selectedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._goToDateInView($event, "year"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("activeDate", ctx_r2._activeDate);
    i0.ɵɵproperty("selected", ctx_r2.selected)("dateFilter", ctx_r2.dateFilter)("maxDate", ctx_r2.maxDate)("minDate", ctx_r2.minDate);
  }
}
function NxCalendarComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "button", 19, 3);
    i0.ɵɵlistener("click", function NxCalendarComponent_Conditional_18_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.todayButtonHandler());
    })("keydown", function NxCalendarComponent_Conditional_18_Template_button_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.todayButtonKeydownHandler($event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2._disableTodayButton);
    i0.ɵɵattribute("aria-label", ctx_r2._intl.todayButtonAriaLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2._intl.todayButtonLabel, " ");
  }
}
const _c9 = ["closeButton"];
const _c10 = ["toggleButton"];
const _c11 = [[["", "nxDatepickerToggleIcon", ""]]];
const _c12 = ["[nxDatepickerToggleIcon]"];
function NxDatepickerToggleComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nx-icon", 2);
  }
}
class NxDateAdapter {
  constructor() {
    this.locale = 'de-DE';
    this._localeChanges = new Subject();
  }
  /** A stream that emits when the locale changes. */
  get localeChanges() {
    return this._localeChanges;
  }
  /**
   * Attempts to deserialize a value to a valid date object. This is different from parsing in that
   * deserialize should only accept non-ambiguous, locale-independent formats (e.g. an ISO 8601
   * string). The default implementation does not allow any deserialization, it simply checks that
   * the given value is already a valid date object or null. The `<nx-datefield>` will call this
   * method on all of its `@Input()` properties that accept dates. It is therefore possible to
   * support passing values from your backend directly to these properties by overriding this method
   * to also deserialize the format used by your backend.
   * @param value The value to be deserialized into a date object.
   * @returns The deserialized date object, either a valid date, null if the value can be deserialized into a null date (e.g. the empty string), or an invalid date.
   */
  deserialize(value) {
    if (value == null || this.isDateInstance(value) && this.isValid(value)) {
      return value;
    }
    return this.invalid();
  }
  /**
   * Checks if two dates are equal.
   * @param first The first date to check.
   * @param second The second date to check.
   * @returns True if the two dates are equal. Null dates are considered equal to other null dates.
   */
  sameDate(first, second) {
    if (first && second) {
      const firstValid = this.isValid(first);
      const secondValid = this.isValid(second);
      if (firstValid && secondValid) {
        return !this.compareDate(first, second);
      }
      return firstValid === secondValid;
    }
    return first === second;
  }
  /**
   * Compares two dates.
   * @param first The first date to compare.
   * @param second The second date to compare.
   * @returns 0 if the dates are equal, a number less than 0 if the first date is earlier, a number greater than 0 if the first date is later.
   */
  compareDate(first, second) {
    return this.getYear(first) - this.getYear(second) || this.getMonth(first) - this.getMonth(second) || this.getDate(first) - this.getDate(second);
  }
  /**
   * Sets the locale used for all dates.
   * @param locale The new locale.
   */
  setLocale(locale) {
    this.locale = locale;
    this._localeChanges.next(this.locale);
  }
  /** Returns the current set locale of the adapter. */
  getLocale() {
    return this.locale;
  }
  /**
   * Clamp the given date between min and max dates.
   * @param date The date to clamp.
   * @param min The minimum value to allow. If null or omitted no min is enforced.
   * @param max The maximum value to allow. If null or omitted no max is enforced.
   * @returns `min` if `date` is less than `min`, `max` if date is greater than `max`,
   * otherwise `date`.
   */
  clampDate(date, min, max) {
    if (min && this.compareDate(date, min) < 0) {
      return min;
    }
    if (max && this.compareDate(date, max) > 0) {
      return max;
    }
    return date;
  }
}
const NX_DATE_FORMATS = new InjectionToken('nx-date-formats');
const NX_DATE_STRICT = new InjectionToken('nx-date-strict');

/** InjectionToken for datepicker that can be used to override default locale code. */
const NX_DATE_LOCALE = new InjectionToken('nx-date-locale');

// TODO(mmalerba): Remove when we no longer support safari 9.
/** Whether the browser supports the Intl API. */
const SUPPORTS_INTL_API = typeof Intl !== 'undefined';
/** The default month names to use if Intl API is not available. */
const DEFAULT_MONTH_NAMES = {
  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
};
/** The default date names to use if Intl API is not available. */
const DEFAULT_DATE_NAMES = range(31, i => String(i + 1));
/** The default day of the week names to use if Intl API is not available. */
const DEFAULT_DAY_OF_WEEK_NAMES = {
  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
};
/**
 * Matches strings that have the form of a valid RFC 3339 string
 * (https://tools.ietf.org/html/rfc3339). Note that the string may not actually be a valid date
 * because the regex will match strings an with out of bounds month, date, etc.
 */
const ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:\+|-)\d{2}:\d{2})?)?$/;
/** Creates an array and fills it with values. */
function range(length, valueFunction) {
  const valuesArray = Array(length);
  for (let i = 0; i < length; i++) {
    valuesArray[i] = valueFunction(i);
  }
  return valuesArray;
}
/**
 * Adapts the native JS Date for use with cdk-based components that work with dates.
 * @docs-private
 */
class NxNativeDateAdapter extends NxDateAdapter {
  constructor(dateLocale, platform) {
    super();
    /**
     * Whether to use `timeZone: 'utc'` with `Intl.DateTimeFormat` when formatting dates.
     * Without this `Intl.DateTimeFormat` sometimes chooses the wrong timeZone, which can throw off
     * the result. (e.g. in the en-US locale `new Date(1800, 7, 14).toLocaleDateString()`
     * will produce `'8/13/1800'`.
     *
     * TODO(mmalerba): drop this variable. It's not being used in the code right now. We're now
     * getting the string representation of a Date object from it's utc representation. We're keeping
     * it here for sometime, just for precaution, in case we decide to revert some of these changes
     * though.
     */
    this.useUtcForDisplay = true;
    super.setLocale(dateLocale || 'en-US');
    // IE does its own time zone correction, so we disable this on IE.
    this.useUtcForDisplay = !platform.TRIDENT;
    this._clampDate = platform.TRIDENT || platform.EDGE;
  }
  getYear(date) {
    return date.getFullYear();
  }
  getMonth(date) {
    return date.getMonth();
  }
  getDate(date) {
    return date.getDate();
  }
  getDayOfWeek(date) {
    return date.getDay();
  }
  getMonthNames(style) {
    if (SUPPORTS_INTL_API) {
      const dtf = new Intl.DateTimeFormat(this.locale, {
        month: style,
        timeZone: 'utc'
      });
      return range(12, i => this._stripDirectionalityCharacters(this._format(dtf, new Date(2017, i, 1))));
    }
    return DEFAULT_MONTH_NAMES[style];
  }
  getDateNames() {
    if (SUPPORTS_INTL_API) {
      const dtf = new Intl.DateTimeFormat(this.locale, {
        day: 'numeric',
        timeZone: 'utc'
      });
      return range(31, i => this._stripDirectionalityCharacters(this._format(dtf, new Date(2017, 0, i + 1))));
    }
    return DEFAULT_DATE_NAMES;
  }
  getDayOfWeekNames(style) {
    if (SUPPORTS_INTL_API) {
      const dtf = new Intl.DateTimeFormat(this.locale, {
        weekday: style,
        timeZone: 'utc'
      });
      return range(7, i => this._stripDirectionalityCharacters(this._format(dtf, new Date(2017, 0, i + 1))));
    }
    return DEFAULT_DAY_OF_WEEK_NAMES[style];
  }
  getYearName(date) {
    if (SUPPORTS_INTL_API) {
      const dtf = new Intl.DateTimeFormat(this.locale, {
        year: 'numeric',
        timeZone: 'utc'
      });
      return this._stripDirectionalityCharacters(this._format(dtf, date));
    }
    return String(this.getYear(date));
  }
  getFirstDayOfWeek() {
    // We can't tell using native JS Date what the first day of the week is, we default to Sunday.
    return 0;
  }
  getNumDaysInMonth(date) {
    return this.getDate(this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + 1, 0));
  }
  clone(date) {
    return this.createDate(this.getYear(date), this.getMonth(date), this.getDate(date));
  }
  createDate(year, month, date) {
    // Check for invalid month and date (except upper bound on date which we have to check after
    // creating the Date).
    if (month < 0 || month > 11) {
      throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
    }
    if (date < 1) {
      throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
    }
    const result = this._createDateWithOverflow(year, month, date);
    // Check that the date wasn't above the upper bound for the month, causing the month to overflow
    if (result.getMonth() !== month) {
      throw Error(`Invalid date "${date}" for month with index "${month}".`);
    }
    return result;
  }
  today() {
    return new Date();
  }
  parse(value) {
    // We have no way using the native JS Date to set the parse format or locale, so we ignore these
    // parameters.
    if (typeof value === 'number') {
      return new Date(value);
    }
    return value ? new Date(Date.parse(value)) : null;
  }
  format(date, displayFormat) {
    if (!this.isValid(date)) {
      throw Error('NxNativeDateAdapter: Cannot format invalid date.');
    }
    if (SUPPORTS_INTL_API) {
      // On IE and Edge the i18n API will throw a hard error that can crash the entire app
      // if we attempt to format a date whose year is less than 1 or greater than 9999.
      if (this._clampDate && (date.getFullYear() < 1 || date.getFullYear() > 9999)) {
        date = this.clone(date);
        date.setFullYear(Math.max(1, Math.min(9999, date.getFullYear())));
      }
      displayFormat = {
        ...displayFormat,
        timeZone: 'utc'
      };
      const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
      return this._stripDirectionalityCharacters(this._format(dtf, date));
    }
    return this._stripDirectionalityCharacters(date.toDateString());
  }
  addCalendarYears(date, years) {
    return this.addCalendarMonths(date, years * 12);
  }
  addCalendarMonths(date, months) {
    let newDate = this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + months, this.getDate(date));
    // It's possible to wind up in the wrong month if the original month has more days than the new
    // month. In this case we want to go to the last day of the desired month.
    // Note: the additional + 12 % 12 ensures we end up with a positive number, since JS % doesn't
    // guarantee this.
    if (this.getMonth(newDate) !== ((this.getMonth(date) + months) % 12 + 12) % 12) {
      newDate = this._createDateWithOverflow(this.getYear(newDate), this.getMonth(newDate), 0);
    }
    return newDate;
  }
  addCalendarDays(date, days) {
    return this._createDateWithOverflow(this.getYear(date), this.getMonth(date), this.getDate(date) + days);
  }
  toIso8601(date) {
    return [date.getUTCFullYear(), this._2digit(date.getUTCMonth() + 1), this._2digit(date.getUTCDate())].join('-');
  }
  /**
   * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
   * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
   * invalid date for all other values.
   */
  deserialize(value) {
    if (typeof value === 'string') {
      if (!value) {
        return null;
      }
      // The `Date` constructor accepts formats other than ISO 8601, so we need to make sure the
      // string is the right format first.
      if (ISO_8601_REGEX.test(value)) {
        const date = new Date(value);
        if (this.isValid(date)) {
          return date;
        }
      }
    }
    return super.deserialize(value);
  }
  isDateInstance(obj) {
    return obj instanceof Date;
  }
  isValid(date) {
    return !isNaN(date.getTime());
  }
  invalid() {
    return new Date(NaN);
  }
  /** Creates a date but allows the month and date to overflow. */
  _createDateWithOverflow(year, month, date) {
    const result = new Date(year, month, date);
    // We need to correct for the fact that JS native Date treats years in range [0, 99] as
    // abbreviations for 19xx.
    if (year >= 0 && year < 100) {
      result.setFullYear(this.getYear(result) - 1900);
    }
    return result;
  }
  /**
   * Pads a number to make it two digits.
   * @param n The number to pad.
   * @returns The padded number.
   */
  _2digit(n) {
    return ('00' + n).slice(-2);
  }
  /**
   * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
   * other browsers do not. We remove them to make output consistent and because they interfere with
   * date parsing.
   * @param str The string to strip direction characters from.
   * @returns The stripped string.
   */
  _stripDirectionalityCharacters(str) {
    return str.replace(/[\u200e\u200f]/g, '');
  }
  /**
   * When converting Date object to string, javascript built-in functions may return wrong
   * results because it applies its internal DST rules. The DST rules around the world change
   * very frequently, and the current valid rule is not always valid in previous years though.
   * We work around this problem building a new Date object which has its internal UTC
   * representation with the local date and time.
   * @param dtf Intl.DateTimeFormat object, containg the desired string format. It must have timeZone set to 'utc' to work fine.
   * @param date Date from which we want to get the string representation according to dtf.
   * @returns A Date object with its UTC representation based on the passed in date info.
   */
  _format(dtf, date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    return dtf.format(d);
  }
  static {
    this.ɵfac = function NxNativeDateAdapter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxNativeDateAdapter)(i0.ɵɵinject(NX_DATE_LOCALE, 8), i0.ɵɵinject(i1.Platform));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NxNativeDateAdapter,
      factory: NxNativeDateAdapter.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxNativeDateAdapter, [{
    type: Injectable
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NX_DATE_LOCALE]
    }]
  }, {
    type: i1.Platform
  }], null);
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const NX_NATIVE_DATE_FORMATS = {
  parse: {
    dateInput: null
  },
  display: {
    dateInput: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    },
    monthYearLabel: {
      year: 'numeric',
      month: 'short'
    },
    dateA11yLabel: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },
    monthYearA11yLabel: {
      year: 'numeric',
      month: 'long'
    }
  }
};
const NX_DATE_LOCALE_PROVIDER = {
  provide: NX_DATE_LOCALE,
  useFactory: (localeId, nxDateLocale) => {
    if (nxDateLocale !== null) {
      return nxDateLocale;
    }
    return localeId;
  },
  deps: [LOCALE_ID, [new SkipSelf(), new Optional(), NX_DATE_LOCALE]]
};
class NativeDateModule {
  static {
    this.ɵfac = function NativeDateModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NativeDateModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NativeDateModule,
      imports: [PlatformModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: NxDateAdapter,
        useClass: NxNativeDateAdapter
      }, NX_DATE_LOCALE_PROVIDER],
      imports: [PlatformModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NativeDateModule, [{
    type: NgModule,
    args: [{
      imports: [PlatformModule],
      providers: [{
        provide: NxDateAdapter,
        useClass: NxNativeDateAdapter
      }, NX_DATE_LOCALE_PROVIDER]
    }]
  }], null, null);
})();
class NxNativeDateModule {
  static {
    this.ɵfac = function NxNativeDateModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxNativeDateModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NxNativeDateModule,
      imports: [NativeDateModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: NX_DATE_FORMATS,
        useValue: NX_NATIVE_DATE_FORMATS
      }],
      imports: [NativeDateModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxNativeDateModule, [{
    type: NgModule,
    args: [{
      imports: [NativeDateModule],
      providers: [{
        provide: NX_DATE_FORMATS,
        useValue: NX_NATIVE_DATE_FORMATS
      }]
    }]
  }], null, null);
})();

/**
 * Provides a set of date validators that can be used by form controls.
 * @dynamic
 */
class NxDateValidators {
  /** The form control validator for whether the input parses. */
  static parse(dateAdapter, dateFormats, input, strict, customParseFormat) {
    return () => {
      if (!input.value) {
        return null;
      }
      const parsedValue = dateAdapter.parse(input.value, customParseFormat || dateFormats.parse.dateInput, strict);
      const valid = parsedValue && dateAdapter.isValid(parsedValue);
      return valid ? null : {
        nxDatefieldParse: {
          text: input
        }
      };
    };
  }
  /** The form control validator for the min date. */
  static min(dateAdapter, min) {
    return control => {
      const controlValue = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value));
      return !min || !controlValue || dateAdapter.compareDate(min, controlValue) <= 0 ? null : {
        nxDatefieldMin: {
          min,
          actual: controlValue
        }
      };
    };
  }
  /** The form control validator for the max date. */
  static max(dateAdapter, max) {
    return control => {
      const controlValue = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value));
      return !max || !controlValue || dateAdapter.compareDate(max, controlValue) >= 0 ? null : {
        nxDatefieldMax: {
          max,
          actual: controlValue
        }
      };
    };
  }
  /** The form control validator for the date filter. */
  static filter(dateAdapter, dateFilter) {
    return control => {
      const controlValue = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value));
      return !dateFilter || !controlValue || dateFilter(controlValue) ? null : {
        nxDatefieldFilter: true
      };
    };
  }
}
class NxDateRangeValidators {
  static min(dateAdapter, min) {
    return control => {
      const controlValue = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.start));
      return !min || !controlValue || dateAdapter.compareDate(min, controlValue) <= 0 ? null : {
        nxDatefieldMin: {
          min,
          actual: controlValue
        }
      };
    };
  }
  /** The form control validator for the max date. */
  static max(dateAdapter, max) {
    return control => {
      const controlValue = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.end));
      return !max || !controlValue || dateAdapter.compareDate(max, controlValue) >= 0 ? null : {
        nxDatefieldMax: {
          max,
          actual: controlValue
        }
      };
    };
  }
  /** The form control validator for the date filter. */
  static filter(dateAdapter, dateFilter) {
    return control => {
      if (!dateFilter) {
        return null;
      }
      const controlValueStart = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.start));
      const controlValueEnd = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.end));
      const startMismatchesFilter = !dateFilter(controlValueStart);
      const endMismatchesFilter = !dateFilter(controlValueEnd);
      const errors = {};
      if (startMismatchesFilter) {
        errors.nxDateRangeStartFilter = true;
      }
      if (endMismatchesFilter) {
        errors.nxDateRangeEndFilter = true;
      }
      return startMismatchesFilter || endMismatchesFilter ? errors : null;
    };
  }
  /** The form control validator to check that the start date is before end date. */
  static range(dateAdapter) {
    return control => {
      const controlValueStart = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.start));
      const controlValueEnd = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.end));
      if (controlValueStart && controlValueEnd && dateAdapter.compareDate(controlValueStart, controlValueEnd) > 0) {
        return {
          nxDateRangeInvalid: true
        };
      }
      return null;
    };
  }
  static complete(dateAdapter) {
    return control => {
      const controlValueStart = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.start));
      const controlValueEnd = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.end));
      const partlyMissing = controlValueStart && !controlValueEnd || !controlValueStart && controlValueEnd;
      if (partlyMissing) {
        return {
          nxDateRangeIncomplete: true
        };
      }
      return null;
    };
  }
  static required(dateAdapter) {
    return control => {
      const controlValueStart = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.start));
      const controlValueEnd = getValidDateOrNull(dateAdapter, dateAdapter.deserialize(control.value?.end));
      const rangePartsMissing = !controlValueStart && !controlValueEnd;
      if (!control.value || rangePartsMissing) {
        return {
          required: true
        };
      }
      return null;
    };
  }
}
function getValidDateOrNull(dateAdapter, obj) {
  return dateAdapter.isDateInstance(obj) && dateAdapter.isValid(obj) ? obj : null;
}

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** @docs-private */
function createMissingDateImplError(provider) {
  return Error(`NxDatepicker: No provider found for ${provider}. You must import one of the following ` + `modules at your application root: NxNativeDateModule, NxMomentDateModule, NxIsoDateModule or provide a ` + `custom implementation.`);
}
class NxDateRangeConnector {}

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const NX_DATEFIELD_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NxDatefieldDirective),
  multi: true
};
const NX_DATEFIELD_VALIDATORS = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => NxDatefieldDirective),
  multi: true
};
/**
 * An event used for datepicker input and change events. We don't always have access to a native
 * input or change event because the event may have been triggered by the user clicking on the
 * calendar popup. For consistency, we always use NxDatepickerInputEvent instead.
 */
class NxDatepickerInputEvent {
  constructor(/** Reference to the datepicker input component that emitted the event. */
  target, /** Reference to the native input element associated with the datepicker input. */
  targetElement) {
    this.target = target;
    this.targetElement = targetElement;
    this.value = this.target.value;
  }
}
/**
 * Directive used to provide date processing functionality to an input.
 */
class NxDatefieldDirective {
  /** The datepicker that this input is associated with. */
  set datepicker(value) {
    this.registerDatepicker(value);
  }
  /** Function that can be used to filter out dates within the datepicker and invalidate values in the datefield. */
  set datefieldFilter(value) {
    this._dateFilter = value;
    this._validatorOnChange();
  }
  /** Provide or read the current date. It's type <D> depends on the chosen date implementation */
  set value(value) {
    value = this._dateAdapter.deserialize(value);
    value = this._getValidDateOrNull(value);
    const oldDate = this.value;
    this._value = value;
    this._formatValue(this.value);
    if (!this._dateAdapter.sameDate(oldDate, value)) {
      this._valueChange.emit(value);
    }
  }
  get value() {
    return this._value;
  }
  /** Sets the minimum valid date. */
  set min(value) {
    this._min = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
    this._validatorOnChange();
  }
  get min() {
    return this._min;
  }
  /** Sets the maximum valid date. */
  set max(value) {
    this._max = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
    this._validatorOnChange();
  }
  get max() {
    return this._max;
  }
  /**
   * If supported by the date implementation enable strict parsing (applies to Moment's parse function here).
   *
   * The date value is not updated on a `strict` change.
   */
  set strict(value) {
    this._strict = coerceBooleanProperty(value);
  }
  get strict() {
    return this._strict;
  }
  /**
   * Override the parse format given with parse.dateInput with the token NX_DATE_FORMATS.
   *
   * The date value is not updated on a `parseFormat` change.
   */
  set parseFormat(value) {
    this._parseFormat = value;
  }
  get parseFormat() {
    return this._parseFormat;
  }
  /** Override the display format given with display.dateInput with the token NX_DATE_FORMATS  */
  set displayFormat(value) {
    this._displayFormat = value;
    this._formatValue(this.value);
  }
  get displayFormat() {
    return this._displayFormat;
  }
  /** Whether the datepicker-input is disabled. */
  set disabled(value) {
    const newValue = coerceBooleanProperty(value);
    if (this._disabled !== newValue) {
      this._disabled = newValue;
      this._disabledChange.emit(newValue);
    }
    // In Ivy static bindings are invoked earlier, before the element is attached to the DOM.
    // This can cause an error to be thrown in some browsers (IE/Edge) which assert that the
    // element has been inserted.
    if (newValue && this._isInitialized) {
      // Normally, native input elements automatically blur if they turn disabled. This behavior
      // is problematic, because it would mean that it triggers another change detection cycle,
      // which then causes a changed after checked error if the input element was focused before.
      this._elementRef.nativeElement.blur();
    }
  }
  get disabled() {
    return !!this._disabled;
  }
  /** Whether the datefield is readonly. */
  setReadonly(value) {
    this.readonly.set(value);
  }
  constructor(/** @docs-private */
  _elementRef, _dateAdapter, _dateFormats, _dateStrict, _formField, _dateRange) {
    this._elementRef = _elementRef;
    this._formField = _formField;
    this._dateRange = _dateRange;
    /** @docs-private */
    this.currentFormattedDate = null;
    /**
     * @docs-private
     * To be able to set the hasPopup from the outside if the datepicker is not available in this directive like the date-range component
     */
    this.hasPopup = input(false);
    this._strict = true;
    /** Whether the datefield is readonly. */
    this.readonly = model(false);
    /** Emits when a `change` event is fired on this `<input>`. */
    this.dateChange = new EventEmitter();
    /** Emits when an `input` event is fired on this `<input>`. */
    this.dateInput = new EventEmitter();
    /** Emits when the value changes (either due to user input or programmatic change). */
    this._valueChange = new EventEmitter();
    /** Emits when the disabled state has changed. */
    this._disabledChange = new EventEmitter();
    /** Emits when the readonly state has changed. */
    this._readonlyChange = new EventEmitter();
    this._destroyed = new Subject();
    this._onTouched = () => {};
    this._cvaOnChange = () => {};
    this._validatorOnChange = () => {};
    if (!_dateAdapter) {
      throw createMissingDateImplError('DateAdapter');
    }
    this._dateAdapter = _dateAdapter;
    if (!_dateFormats) {
      throw createMissingDateImplError('NX_DATE_FORMATS');
    }
    this._dateFormats = _dateFormats;
    this._strict = _dateStrict ?? true;
    // Update the displayed date when the locale changes.
    _dateAdapter.localeChanges.pipe(takeUntil(this._destroyed)).subscribe(() => {
      const value = this.value;
      this.value = value; // invoke setter
    });
    this._readonlyStateChangeEffect = effect(() => {
      this._readonlyChange.emit(this.readonly());
    });
  }
  ngAfterContentInit() {
    this._datepicker?.selectedChanged.pipe(takeUntil(this._destroyed)).subscribe(selected => {
      this.value = selected;
      this._cvaOnChange(this.value);
      this._onTouched();
      this.dateInput.emit(new NxDatepickerInputEvent(this, this._elementRef.nativeElement));
      this.dateChange.emit(new NxDatepickerInputEvent(this, this._elementRef.nativeElement));
    });
    this._isInitialized = true;
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this._valueChange.complete();
    this._disabledChange.complete();
    this._readonlyChange.complete();
    this._readonlyStateChangeEffect.destroy();
  }
  /** @docs-private */
  registerOnValidatorChange(fn) {
    this._validatorOnChange = fn;
  }
  /** @docs-private */
  validate(c) {
    if (this._dateRange) {
      // if the datefield is part of a date range, the validation is handled by the date range.
      return null;
    }
    const validator = Validators.compose(this.getValidators());
    return validator ? validator(c) : null;
  }
  /**
   * Gets the element that the datepicker popup should be connected to.
   * @returns The element to connect the popup to.
   * @docs-private
   */
  getConnectedOverlayOrigin() {
    // formfield not yet accessible as we don't have them in a secondary entry point to import yet.
    // return this._elementRef;
    return this._formField ? this._formField.getConnectedOverlayOrigin() : this._elementRef;
  }
  // Implemented as part of ControlValueAccessor.
  writeValue(value) {
    this.value = value;
  }
  // Implemented as part of ControlValueAccessor.
  registerOnChange(fn) {
    this._cvaOnChange = fn;
  }
  // Implemented as part of ControlValueAccessor.
  registerOnTouched(fn) {
    this._onTouched = fn;
  }
  // Implemented as part of ControlValueAccessor.
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  _onKeydown(event) {
    if (event.altKey && event.keyCode === DOWN_ARROW) {
      this._datepicker?.open();
      event.preventDefault();
    }
  }
  _onInput(value) {
    let date = this._dateAdapter.parse(value, this._parseFormat || this._dateFormats.parse.dateInput, this.strict);
    date = this._getValidDateOrNull(date);
    this._value = date;
    if (date) {
      this.currentFormattedDate = this._dateAdapter.format(date, this._displayFormat || this._dateFormats.display.dateInput);
    } else {
      this.currentFormattedDate = null;
    }
    this._cvaOnChange(date);
    this._valueChange.emit(date);
    this.dateInput.emit(new NxDatepickerInputEvent(this, this._elementRef.nativeElement));
  }
  _onChange() {
    this.dateChange.emit(new NxDatepickerInputEvent(this, this._elementRef.nativeElement));
  }
  _focus() {
    this._elementRef.nativeElement.focus();
  }
  _onBlur() {
    // Reformat the input only if we have a valid value.
    if (this.value) {
      this._formatValue(this.value);
    }
    this._onTouched();
  }
  /** Returns the validators of the datefield. */
  getValidators() {
    return [NxDateValidators.parse(this._dateAdapter, this._dateFormats, this._elementRef.nativeElement, this._strict, this._parseFormat), NxDateValidators.min(this._dateAdapter, this.min), NxDateValidators.max(this._dateAdapter, this.max), NxDateValidators.filter(this._dateAdapter, this._dateFilter)];
  }
  /** Formats a value and sets it on the input native element. */
  _formatValue(value) {
    this._elementRef.nativeElement.value = value ? this._dateAdapter.format(value, this._displayFormat || this._dateFormats.display.dateInput) : '';
  }
  /**
   * @param obj The object to check.
   * @returns The given object if it is both a date instance and valid, otherwise null.
   */
  _getValidDateOrNull(obj) {
    return this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj) ? obj : null;
  }
  registerDatepicker(value) {
    if (value) {
      this._datepicker = value;
      this._datepicker.registerInput(this);
    }
  }
  static {
    this.ɵfac = function NxDatefieldDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDatefieldDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NxDateAdapter, 8), i0.ɵɵdirectiveInject(NX_DATE_FORMATS, 8), i0.ɵɵdirectiveInject(NX_DATE_STRICT, 8), i0.ɵɵdirectiveInject(i2.NxFormfieldComponent, 8), i0.ɵɵdirectiveInject(NxDateRangeConnector, 8));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxDatefieldDirective,
      selectors: [["input", "nxDatefield", ""]],
      hostVars: 6,
      hostBindings: function NxDatefieldDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function NxDatefieldDirective_input_HostBindingHandler($event) {
            return ctx._onInput($event.target.value);
          })("change", function NxDatefieldDirective_change_HostBindingHandler() {
            return ctx._onChange();
          })("blur", function NxDatefieldDirective_blur_HostBindingHandler() {
            return ctx._onBlur();
          })("keydown", function NxDatefieldDirective_keydown_HostBindingHandler($event) {
            return ctx._onKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("disabled", ctx.disabled)("readonly", ctx.readonly());
          i0.ɵɵattribute("aria-haspopup", !!ctx._datepicker || ctx.hasPopup() || null)("aria-owns", (ctx._datepicker == null ? null : ctx._datepicker.opened) && ctx._datepicker.id || null)("min", ctx.min ? ctx._dateAdapter.toIso8601(ctx.min) : null)("max", ctx.max ? ctx._dateAdapter.toIso8601(ctx.max) : null);
        }
      },
      inputs: {
        hasPopup: [1, "hasPopup"],
        datepicker: "datepicker",
        datefieldFilter: "datefieldFilter",
        value: "value",
        min: "min",
        max: "max",
        strict: "strict",
        parseFormat: "parseFormat",
        displayFormat: "displayFormat",
        disabled: "disabled",
        readonly: [1, "readonly"]
      },
      outputs: {
        readonly: "readonlyChange",
        dateChange: "dateChange",
        dateInput: "dateInput"
      },
      exportAs: ["nxDatefield"],
      features: [i0.ɵɵProvidersFeature([NX_DATEFIELD_VALUE_ACCESSOR, NX_DATEFIELD_VALIDATORS,
      // {provide: NX_INPUT_VALUE_ACCESSOR, useExisting: NxDatefieldDirective},
      {
        provide: NX_INPUT_VALUE_ACCESSOR,
        useExisting: NxDatefieldDirective
      }, {
        provide: NxAbstractControl,
        useExisting: NxDatefieldDirective
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDatefieldDirective, [{
    type: Directive,
    args: [{
      selector: 'input[nxDatefield]',
      providers: [NX_DATEFIELD_VALUE_ACCESSOR, NX_DATEFIELD_VALIDATORS,
      // {provide: NX_INPUT_VALUE_ACCESSOR, useExisting: NxDatefieldDirective},
      {
        provide: NX_INPUT_VALUE_ACCESSOR,
        useExisting: NxDatefieldDirective
      }, {
        provide: NxAbstractControl,
        useExisting: NxDatefieldDirective
      }],
      host: {
        '[attr.aria-haspopup]': '!!_datepicker || hasPopup() || null',
        '[attr.aria-owns]': '(_datepicker?.opened && _datepicker.id) || null',
        '[attr.min]': 'min ? _dateAdapter.toIso8601(min) : null',
        '[attr.max]': 'max ? _dateAdapter.toIso8601(max) : null',
        '[disabled]': 'disabled',
        '[readonly]': 'readonly()',
        '(input)': '_onInput($event.target.value)',
        '(change)': '_onChange()',
        '(blur)': '_onBlur()',
        '(keydown)': '_onKeydown($event)'
      },
      exportAs: 'nxDatefield',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: NxDateAdapter,
    decorators: [{
      type: Optional
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NX_DATE_FORMATS]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NX_DATE_STRICT]
    }]
  }, {
    type: i2.NxFormfieldComponent,
    decorators: [{
      type: Optional
    }]
  }, {
    type: NxDateRangeConnector,
    decorators: [{
      type: Optional
    }]
  }], {
    datepicker: [{
      type: Input
    }],
    datefieldFilter: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    strict: [{
      type: Input
    }],
    parseFormat: [{
      type: Input
    }],
    displayFormat: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    dateChange: [{
      type: Output
    }],
    dateInput: [{
      type: Output
    }]
  });
})();
class NxDateRangeIntl {
  constructor() {
    /** ARIA label for the start date input field (used by screen readers) */
    this.startDateAriaLabel = signal('Start Date');
    /** ARIA label for the end date input field (used by screen readers) */
    this.endDateAriaLabel = signal('End Date');
  }
  static {
    this.ɵfac = function NxDateRangeIntl_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDateRangeIntl)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NxDateRangeIntl,
      factory: NxDateRangeIntl.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDateRangeIntl, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class DateRange {
  constructor(start, end) {
    this.start = start;
    this.end = end;
  }
}
class NxDateRangeComponent {
  static {
    this.nextId = 0;
  }
  /** The date range value of type @type {DateRange<D>} */
  set value(value) {
    this.writeValue(value);
  }
  get value() {
    return {
      start: this.startDate(),
      end: this.endDate()
    };
  }
  set required(value) {
    this._required = value;
  }
  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }
  set disabled(value) {
    if (this._disabled !== value) {
      this._disabled = value;
      this.stateChanges.next();
    }
  }
  get disabled() {
    return this._disabled;
  }
  set readonly(value) {
    if (this._readonly !== value) {
      this._readonly = value;
      this.stateChanges.next();
    }
  }
  get readonly() {
    return this._readonly;
  }
  constructor(_elementReference, _focusMonitor, _renderer, _injector, _intl, _formFieldComponent, _dateAdapter) {
    this._elementReference = _elementReference;
    this._focusMonitor = _focusMonitor;
    this._renderer = _renderer;
    this._injector = _injector;
    this._intl = _intl;
    this._formFieldComponent = _formFieldComponent;
    this._dateAdapter = _dateAdapter;
    this._destroyed = new Subject();
    /** The start input field. We need this to connect to the datepicker */
    this._startDateDirective = viewChild.required('startDateFieldDirective');
    /** Effect for connecting the datepicker to the end date field so the date picker can set the value  */
    this._startDateDirectiveEffect = effect(() => {
      const startDateDirective = this._startDateDirective();
      if (startDateDirective) {
        this.datepicker()?.registerInput(startDateDirective, 'start');
      }
    });
    /** The end date input field. We need this to connect the datepicker */
    this._endDateDirective = viewChild.required('endDateFieldDirective');
    /** Effect for connecting the datepicker to the end date field so the date picker can set the value  */
    this._endDateDirectiveEffect = effect(() => {
      const endDateDirective = this._endDateDirective();
      if (endDateDirective) {
        this.datepicker()?.registerInput(endDateDirective, 'end');
      }
    });
    /**
     * Value of the start date input field
     */
    this.startDate = model(null);
    /**
     * Value of the end date input field
     */
    this.endDate = model(null);
    /**
     * The width of the start date input field. This is set dynamically based on the content of the input field.
     */
    this.startDateInputWidth = model();
    /**
     * The minimum date that can be selected. The date must be same or after the minimum date.
     */
    this.minDate = input(null);
    /**
     * The maximum date that can be selected. The date must be same or before the maximum date.
     */
    this.maxDate = input(null);
    this.dateFilter = input(null);
    this._dateFilterEffect = effect(() => {
      if (this.datepicker() && this.dateFilter()) {
        this.datepicker().dateFilter = this.dateFilter();
      }
    });
    /**
     * The NxDatePicker this date range should connect to
     */
    this.datepicker = input();
    /** State changes subject to notifiy the Formfield of changes */
    this.stateChanges = new Subject();
    this.empty = false;
    this.id = `nx-date-range-${NxDateRangeComponent.nextId++}`;
    this.focused = false;
    this._required = false;
    this._disabled = false;
    this._readonly = false;
    this.shouldLabelFloat = true;
    /** Wether the component has an invalid value */
    this.errorState = false;
    this.placeholder = '';
    /**
     * The aria-describedby ids that will be set by the formfield
     */
    this.ariaDescribedByFormfield = signal(null);
    /**
     * The aria-describedby attribute on the input for improved accessibility.
     */
    this.ariaDescribedByInput = input(null, {
      alias: 'ariaDescribedBy'
    });
    this.ariaDescribedBy = computed(() => {
      const input = this.ariaDescribedByInput();
      const formfield = this.ariaDescribedByFormfield();
      if (input && formfield) {
        return `${input}, ${formfield.join(' ')}`;
      } else if (input) {
        return input;
      }
      return formfield?.join(' ') || null;
    });
    this.groupAriaLabel = model(null);
    this.startDateAriaLabelInput = input(null, {
      alias: 'startDateAriaLabel'
    });
    this.startDateAriaLabel = computed(() => {
      const test = this.startDateAriaLabelInput() || this._intl.startDateAriaLabel();
      return test;
    });
    this.endDateAriaLabelInput = input(null, {
      alias: 'startDateAriaLabel'
    });
    this.endDateAriaLabel = computed(() => this.endDateAriaLabelInput() || this._intl.endDateAriaLabel());
    this.parseFormat = input('');
    this.displayFormat = input('');
    this.strict = input(true);
    /**
     * Callback function that is called when the control's value changes in the UI.
     */
    this.onChange = _ => {};
    /**
     * Callback function that is called when the control's is touched.
     */
    this.onTouched = () => {};
    this.ngControl = null;
    if (!_dateAdapter) {
      throw createMissingDateImplError('DateAdapter');
    }
    // Since we need to use the window object we need to call it in the afterRender hook to be SSR compatible.
    this._dynamicStartDateWidthHook = afterRender(() => {
      let measuredWidth = 0;
      if (!this._measureCanvas) {
        this._measureCanvas = this._renderer.createElement('canvas');
      }
      const ctx = this._measureCanvas.getContext('2d');
      if (!ctx) {
        throw new Error('Could not get 2d context');
      }
      const inputRef = this._startDateDirective()._elementRef;
      const styles = window.getComputedStyle(inputRef.nativeElement);
      ctx.font = getFontShorthand(styles);
      let startInputContent = '';
      if (inputRef.nativeElement.value.length > 0) {
        startInputContent = inputRef.nativeElement.value;
      } else {
        startInputContent = inputRef.nativeElement.placeholder;
      }
      const metrics = ctx.measureText(startInputContent);
      // add 1px (cursor width) to prevent jumping of the text on blur.
      const newWidth = metrics.width + parseInt(styles.paddingRight, 10) + parseInt(styles.paddingLeft, 10) + 1;
      // This should be injected via @Host to get an exact reference to NxNaturalLanguageFormComponent
      // Works as promised as long as there is not other tag around the word. Not expected but possible.
      const parent = inputRef.nativeElement.parentElement;
      const parentMeasurement = parent.getBoundingClientRect();
      // Limit to own given minimal width
      measuredWidth = Math.max(parseInt(styles.minWidth, 10), newWidth);
      // Limit to container width
      measuredWidth = Math.min(measuredWidth, parentMeasurement.width);
      measuredWidth = Math.round(measuredWidth);
      this.startDateInputWidth.set(`${measuredWidth}px`);
    });
  }
  ngOnInit() {
    this.ngControl = this._injector.get(NgControl, null);
  }
  ngDoCheck() {
    if (this.ngControl && this.ngControl.touched && (!this.datepicker()?.opened || this.ngControl.valid || !this.datepicker())) {
      this.errorState = !this.ngControl.valid;
    }
  }
  validate(control) {
    const validator = Validators.compose(this.getValidators());
    return validator ? validator(control) : null;
  }
  getValidators() {
    const validators = [NxDateRangeValidators.complete(this._dateAdapter), NxDateRangeValidators.range(this._dateAdapter), NxDateRangeValidators.min(this._dateAdapter, this.minDate()), NxDateRangeValidators.max(this._dateAdapter, this.maxDate()), NxDateRangeValidators.filter(this._dateAdapter, this.dateFilter())];
    if (this.required) {
      validators.push(NxDateRangeValidators.required(this._dateAdapter));
    }
    return validators;
  }
  registerOnValidatorChange(fn) {}
  setReadonly(value) {
    this.readonly = value;
  }
  setDescribedByIds(ids) {
    this.ariaDescribedByFormfield.set(ids);
  }
  setAriaLabel(value) {
    this.groupAriaLabel.set(value);
  }
  get elementRef() {
    return this._elementReference;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  ngAfterViewInit() {
    this._focusMonitor.monitor(this._elementReference, true).pipe(takeUntil(this._destroyed)).subscribe(origin => {
      if (this.focused && !origin) {
        this.onTouched();
      }
      this.focused = !!origin;
      this.stateChanges.next();
    });
    this.datepicker()?.selectedChanged.pipe(takeUntil(this._destroyed)).subscribe(selected => {
      this.startDate.set(selected.start);
      this.endDate.set(selected.end);
      this._startDateDirective().value = selected.start;
      this._endDateDirective().value = selected.end;
      this.onChange({
        start: selected.start,
        end: selected.end
      });
    });
    this.datepicker()?.closedStream.pipe(takeUntil(this._destroyed)).subscribe(() => {
      this.onTouched();
      this.stateChanges.next();
    });
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._focusMonitor.stopMonitoring(this._elementReference);
    this._dynamicStartDateWidthHook.destroy();
    this._startDateDirectiveEffect.destroy();
    this._endDateDirectiveEffect.destroy();
    this._dateFilterEffect.destroy();
    this._destroyed.complete();
  }
  writeValue(obj) {
    this.startDate.set(obj?.start || null);
    this.endDate.set(obj?.end || null);
    if (this.datepicker()) {
      this.datepicker().selected = {
        start: this.startDate(),
        end: this.endDate()
      };
    }
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  handleChange() {
    this.onChange({
      start: this.startDate(),
      end: this.endDate()
    });
  }
  getAriaLabelId() {
    return this._formFieldComponent?.labelId || null;
  }
  _onKeydown(event) {
    if (event.altKey && event.keyCode === DOWN_ARROW) {
      this.datepicker()?.open();
      event.preventDefault();
    }
  }
  static {
    this.ɵfac = function NxDateRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDateRangeComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.FocusMonitor), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(NxDateRangeIntl), i0.ɵɵdirectiveInject(i2.NxFormfieldComponent, 8), i0.ɵɵdirectiveInject(NxDateAdapter));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxDateRangeComponent,
      selectors: [["nx-date-range"]],
      viewQuery: function NxDateRangeComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx._startDateDirective, _c0, 5);
          i0.ɵɵviewQuerySignal(ctx._endDateDirective, _c1, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      hostAttrs: ["role", "group"],
      hostVars: 6,
      hostBindings: function NxDateRangeComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id);
          i0.ɵɵattribute("aria-describedby", ctx.ariaDescribedBy())("aria-label", ctx.groupAriaLabel())("aria-labelledby", ctx.getAriaLabelId());
          i0.ɵɵclassProp("has-error", ctx.errorState);
        }
      },
      inputs: {
        startDate: [1, "startDate"],
        endDate: [1, "endDate"],
        startDateInputWidth: [1, "startDateInputWidth"],
        minDate: [1, "minDate"],
        maxDate: [1, "maxDate"],
        dateFilter: [1, "dateFilter"],
        datepicker: [1, "datepicker"],
        value: "value",
        required: [2, "required", "required", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        readonly: [2, "readonly", "readonly", booleanAttribute],
        placeholder: "placeholder",
        ariaDescribedByInput: [1, "ariaDescribedBy", "ariaDescribedByInput"],
        groupAriaLabel: [1, "groupAriaLabel"],
        startDateAriaLabelInput: [1, "startDateAriaLabel", "startDateAriaLabelInput"],
        endDateAriaLabelInput: [1, "startDateAriaLabel", "endDateAriaLabelInput"],
        parseFormat: [1, "parseFormat"],
        displayFormat: [1, "displayFormat"],
        strict: [1, "strict"]
      },
      outputs: {
        startDate: "startDateChange",
        endDate: "endDateChange",
        startDateInputWidth: "startDateInputWidthChange",
        groupAriaLabel: "groupAriaLabelChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NxFormfieldControl,
        useExisting: NxDateRangeComponent
      }, {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NxDateRangeComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => NxDateRangeComponent),
        multi: true
      }, {
        provide: NxAbstractControl,
        useExisting: forwardRef(() => NxDateRangeComponent)
      }, {
        provide: NxDateRangeConnector,
        useExisting: forwardRef(() => NxDateRangeComponent)
      }])],
      decls: 6,
      vars: 36,
      consts: [["startDateFieldDirective", "nxDatefield"], ["endDateFieldDirective", "nxDatefield"], [1, "date-range-container"], ["nxDatefield", "", 1, "start-date-input", "c-input", 3, "ngModelChange", "keydown", "placeholder", "ngModel", "min", "disabled", "hasPopup", "readonly", "parseFormat", "displayFormat", "strict"], ["nxDatefield", "", 1, "c-input", 3, "ngModelChange", "keydown", "placeholder", "ngModel", "max", "disabled", "hasPopup", "readonly", "parseFormat", "displayFormat", "strict"]],
      template: function NxDateRangeComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2)(1, "input", 3, 0);
          i0.ɵɵtwoWayListener("ngModelChange", function NxDateRangeComponent_Template_input_ngModelChange_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.startDate, $event) || (ctx.startDate = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("ngModelChange", function NxDateRangeComponent_Template_input_ngModelChange_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleChange());
          })("keydown", function NxDateRangeComponent_Template_input_keydown_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._onKeydown($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtext(3, " - ");
          i0.ɵɵelementStart(4, "input", 4, 1);
          i0.ɵɵtwoWayListener("ngModelChange", function NxDateRangeComponent_Template_input_ngModelChange_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.endDate, $event) || (ctx.endDate = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("ngModelChange", function NxDateRangeComponent_Template_input_ngModelChange_4_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleChange());
          })("keydown", function NxDateRangeComponent_Template_input_keydown_4_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._onKeydown($event));
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵstyleProp("width", ctx.startDateInputWidth());
          i0.ɵɵclassProp("is-disabled", ctx.disabled)("has-error", ctx.errorState);
          i0.ɵɵproperty("placeholder", ctx.placeholder);
          i0.ɵɵtwoWayProperty("ngModel", ctx.startDate);
          i0.ɵɵproperty("min", ctx.minDate())("disabled", ctx.disabled)("hasPopup", !!ctx.datepicker())("readonly", ctx.readonly)("parseFormat", ctx.parseFormat())("displayFormat", ctx.displayFormat())("strict", ctx.strict());
          i0.ɵɵattribute("aria-label", ctx.startDateAriaLabel())("aria-describedby", ctx.ariaDescribedBy())("aria-required", ctx.required)("aria-invalid", ctx.errorState);
          i0.ɵɵadvance(3);
          i0.ɵɵclassProp("is-disabled", ctx.disabled)("has-error", ctx.errorState);
          i0.ɵɵproperty("placeholder", ctx.placeholder);
          i0.ɵɵtwoWayProperty("ngModel", ctx.endDate);
          i0.ɵɵproperty("max", ctx.maxDate())("disabled", ctx.disabled)("hasPopup", !!ctx.datepicker())("readonly", ctx.readonly)("parseFormat", ctx.parseFormat())("displayFormat", ctx.displayFormat())("strict", ctx.strict());
          i0.ɵɵattribute("aria-label", ctx.endDateAriaLabel())("aria-describedby", ctx.ariaDescribedBy())("aria-required", ctx.required)("aria-invalid", ctx.errorState);
        }
      },
      dependencies: [NxDatefieldDirective, FormsModule, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, CommonModule],
      styles: ["[_nghost-%COMP%]{width:100%;max-width:100%}[_nghost-%COMP%]   .start-date-input[_ngcontent-%COMP%]{flex-shrink:0}[_nghost-%COMP%]   .date-range-container[_ngcontent-%COMP%]{display:flex;gap:8px;width:100%;text-align:inherit;font-size:inherit;font-weight:inherit;background:0 0;color:inherit;border:none;outline:0;padding:0;margin:0;height:100%;align-items:center}[_nghost-%COMP%]   input[_ngcontent-%COMP%]{min-width:100px}[_nghost-%COMP%]   .separator-icon-span[_ngcontent-%COMP%]{display:flex;align-items:center}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDateRangeComponent, [{
    type: Component,
    args: [{
      selector: 'nx-date-range',
      imports: [NxDatefieldDirective, FormsModule, CommonModule],
      providers: [{
        provide: NxFormfieldControl,
        useExisting: NxDateRangeComponent
      }, {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NxDateRangeComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => NxDateRangeComponent),
        multi: true
      }, {
        provide: NxAbstractControl,
        useExisting: forwardRef(() => NxDateRangeComponent)
      }, {
        provide: NxDateRangeConnector,
        useExisting: forwardRef(() => NxDateRangeComponent)
      }],
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      host: {
        role: 'group',
        '[attr.aria-describedby]': 'ariaDescribedBy()',
        '[attr.aria-label]': 'groupAriaLabel()',
        '[attr.aria-labelledby]': 'getAriaLabelId()',
        '[id]': 'id',
        '[class.has-error]': 'errorState'
      },
      template: "<div class=\"date-range-container\">\n    <input\n        class=\"start-date-input c-input\"\n        [class.is-disabled]=\"disabled\"\n        [class.has-error]=\"errorState\"\n        nxDatefield\n        #startDateFieldDirective=\"nxDatefield\"\n        [attr.aria-label]=\"startDateAriaLabel()\"\n        [attr.aria-describedby]=\"ariaDescribedBy()\"\n        [attr.aria-required]=\"required\"\n        [attr.aria-invalid]=\"errorState\"\n        [placeholder]=\"placeholder\"\n        [(ngModel)]=\"startDate\"\n        (ngModelChange)=\"handleChange()\"\n        [style.width]=\"startDateInputWidth()\"\n        [min]=\"minDate()\"\n        [disabled]=\"disabled\"\n        [hasPopup]=\"!!datepicker()\"\n        (keydown)=\"_onKeydown($event)\"\n        [readonly]=\"readonly\"\n        [parseFormat]=\"parseFormat()\"\n        [displayFormat]=\"displayFormat()\"\n        [strict]=\"strict()\"\n    />\n    -\n    <input\n        class=\"c-input\"\n        [class.is-disabled]=\"disabled\"\n        [class.has-error]=\"errorState\"\n        nxDatefield\n        #endDateFieldDirective=\"nxDatefield\"\n        [attr.aria-label]=\"endDateAriaLabel()\"\n        [attr.aria-describedby]=\"ariaDescribedBy()\"\n        [attr.aria-required]=\"required\"\n        [attr.aria-invalid]=\"errorState\"\n        [placeholder]=\"placeholder\"\n        [(ngModel)]=\"endDate\"\n        (ngModelChange)=\"handleChange()\"\n        [max]=\"maxDate()\"\n        [disabled]=\"disabled\"\n        [hasPopup]=\"!!datepicker()\"\n        (keydown)=\"_onKeydown($event)\"\n        [readonly]=\"readonly\"\n        [parseFormat]=\"parseFormat()\"\n        [displayFormat]=\"displayFormat()\"\n        [strict]=\"strict()\"\n    />\n</div>\n",
      styles: [":host{width:100%;max-width:100%}:host .start-date-input{flex-shrink:0}:host .date-range-container{display:flex;gap:8px;width:100%;text-align:inherit;font-size:inherit;font-weight:inherit;background:0 0;color:inherit;border:none;outline:0;padding:0;margin:0;height:100%;align-items:center}:host input{min-width:100px}:host .separator-icon-span{display:flex;align-items:center}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1$1.FocusMonitor
  }, {
    type: i0.Renderer2
  }, {
    type: i0.Injector
  }, {
    type: NxDateRangeIntl
  }, {
    type: i2.NxFormfieldComponent,
    decorators: [{
      type: Optional
    }]
  }, {
    type: NxDateAdapter
  }], {
    value: [{
      type: Input
    }],
    required: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    readonly: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    placeholder: [{
      type: Input
    }]
  });
})();

/**
 * An internal class that represents the data corresponding to a single calendar cell.
 * @docs-private
 */
class NxCalendarCell {
  constructor(value, displayValue, ariaLabel, enabled) {
    this.value = value;
    this.displayValue = displayValue;
    this.ariaLabel = ariaLabel;
    this.enabled = enabled;
  }
}
/**
 * An internal component used to display calendar data in a table.
 * @docs-private
 */
class NxCalendarBodyComponent {
  constructor(_elementRef, _focusMonitor) {
    this._elementRef = _elementRef;
    this._focusMonitor = _focusMonitor;
    /** The value in the table that is currently selected. */
    this.selectedValue = null;
    this.selectedEndDate = input(null);
    this.betweenRange = input([]);
    /** The number of columns in the table. */
    this.numCols = 7;
    /** Whether to allow selection of disabled cells. */
    this.allowDisabledSelection = false;
    /** The cell number of the active cell in the table. */
    this.activeCell = 0;
    /** The items to display in the first row in the offset space. */
    this.previousItems = 0;
    /** The items to display in the last row in the offset space. */
    this.followingItems = 0;
    /** Emits when a new value out of rows is selected. */
    this.selectedValueChange = new EventEmitter();
    this.hoverValueChange = new EventEmitter();
    /** Emits when a new value out of previousItems is selected. */
    this.selectedValueChangeToPrevious = new EventEmitter();
    /** Emits when a new value out of followingItems is selected. */
    this.selectedValueChangeToFollowing = new EventEmitter();
    this._injector = inject(Injector);
    /**
     * Used to focus the active cell after change detection has run.
     */
    this._focusActiveCellAfterViewChecked = false;
    this._destroyed = new Subject();
  }
  ngAfterViewInit() {
    this._cells.forEach(cell => this._focusMonitor.monitor(cell));
    this._cellsPrevious = this._cells;
    this._cells.changes.pipe(takeUntil(this._destroyed)).subscribe(changes => {
      this._cellsPrevious.forEach(cell => this._focusMonitor.stopMonitoring(cell));
      this._cellsPrevious = this._cells;
      this._cells.forEach(cell => this._focusMonitor.monitor(cell));
    });
  }
  ngAfterViewChecked() {
    if (this._focusActiveCellAfterViewChecked) {
      this._focusActiveCell();
      this._focusActiveCellAfterViewChecked = false;
    }
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this._cells.forEach(cell => this._focusMonitor.stopMonitoring(cell));
  }
  _previousCellClicked(cell) {
    if (!this.allowDisabledSelection && !cell.enabled) {
      return;
    }
    this.selectedValueChangeToPrevious.emit(cell.value);
  }
  _cellClicked(cell) {
    if (!this.allowDisabledSelection && !cell.enabled) {
      return;
    }
    this.selectedValueChange.emit(cell.value);
  }
  _cellFocused(cell) {
    this.hoverValueChange.emit(cell.value);
  }
  _followingCellClicked(cell) {
    if (!this.allowDisabledSelection && !cell.enabled) {
      return;
    }
    this.selectedValueChangeToFollowing.emit(cell.value);
  }
  /** The number of blank cells to put at the beginning for the first row. */
  get _firstRowOffset() {
    return this.rows?.length && this.rows[0].length ? this.numCols - this.rows[0].length : 0;
  }
  /** The number of blank cells to put at the end of the last filled row. */
  get _lastRowOffset() {
    return this.rows?.length && this.rows[this.rows.length - 1].length ? this.numCols - this.rows[this.rows.length - 1].length : 0;
  }
  /** The index of the last row. */
  get _lastRowIndex() {
    return this.rows?.length ? this.rows.length - 1 : 0;
  }
  _isActiveCell(rowIndex, colIndex) {
    let cellNumber = rowIndex * this.numCols + colIndex;
    // Account for the fact that the first row may not have as many cells.
    if (rowIndex) {
      cellNumber -= this._firstRowOffset;
    }
    return cellNumber === this.activeCell;
  }
  /** Focuses the active cell after the microtask queue is empty. */
  _focusActiveCell() {
    afterNextRender({
      read: () => {
        this._elementRef.nativeElement.querySelector('.nx-calendar-body-active').focus();
      }
    }, {
      injector: this._injector
    });
  }
  /** Focuses the active cell after change detection has run and the microtask queue is empty. */
  _scheduleFocusActiveCellAfterViewChecked() {
    this._focusActiveCellAfterViewChecked = true;
  }
  static {
    this.ɵfac = function NxCalendarBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxCalendarBodyComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.FocusMonitor));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxCalendarBodyComponent,
      selectors: [["", "nx-calendar-body", ""]],
      viewQuery: function NxCalendarBodyComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._cells = _t);
        }
      },
      hostAttrs: ["role", "grid", "attr.aria-readonly", "true", 1, "nx-calendar-body"],
      inputs: {
        label: "label",
        rows: "rows",
        todayValue: "todayValue",
        selectedValue: "selectedValue",
        selectedEndDate: [1, "selectedEndDate"],
        betweenRange: [1, "betweenRange"],
        numCols: "numCols",
        allowDisabledSelection: "allowDisabledSelection",
        activeCell: "activeCell",
        previousItems: "previousItems",
        followingItems: "followingItems"
      },
      outputs: {
        selectedValueChange: "selectedValueChange",
        hoverValueChange: "hoverValueChange",
        selectedValueChangeToPrevious: "selectedValueChangeToPrevious",
        selectedValueChangeToFollowing: "selectedValueChangeToFollowing"
      },
      exportAs: ["nxCalendarBody"],
      attrs: _c3,
      decls: 2,
      vars: 0,
      consts: [["cell", ""], ["role", "row"], ["role", "gridcell", 1, "nx-calendar-body-cell", 3, "width", "range-start", "range-end", "in-range", "range-row-start", "range-row-end"], ["aria-hidden", "true"], ["role", "gridcell", 1, "nx-calendar-body-cell"], ["role", "button", 1, "nx-calendar-body-cell-content", 3, "click", "focus", "mouseover", "tabindex"]],
      template: function NxCalendarBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵrepeaterCreate(0, NxCalendarBodyComponent_For_1_Template, 5, 2, "tr", 1, _forTrack0);
        }
        if (rf & 2) {
          i0.ɵɵrepeater(ctx.rows);
        }
      },
      styles: [".nx-calendar-body-cell[_ngcontent-%COMP%], .nx-calendar-adjacent-cell[_ngcontent-%COMP%]{position:relative;height:0;line-height:0;text-align:center;outline:none;vertical-align:text-bottom;cursor:pointer;border-top:2px;border-top-style:solid;border-top-color:var(--ui-background);border-bottom:2px;border-bottom-style:solid;border-bottom-color:var(--ui-background)}.nx-calendar-body-cell.range-start[_ngcontent-%COMP%], .nx-calendar-adjacent-cell.range-start[_ngcontent-%COMP%]{background-color:var(--datepicker-range-background-color);border-top-left-radius:50%;border-bottom-left-radius:50%}.nx-calendar-body-cell.range-end[_ngcontent-%COMP%], .nx-calendar-adjacent-cell.range-end[_ngcontent-%COMP%]{background-color:var(--datepicker-range-background-color);border-bottom-right-radius:50%;border-top-right-radius:50%}.nx-calendar-body-cell.in-range[_ngcontent-%COMP%], .nx-calendar-adjacent-cell.in-range[_ngcontent-%COMP%]{background-color:var(--datepicker-range-background-color)}.nx-calendar-body-cell.range-row-start[_ngcontent-%COMP%], .nx-calendar-adjacent-cell.range-row-start[_ngcontent-%COMP%]{border-top-left-radius:50%;border-bottom-left-radius:50%}.nx-calendar-body-cell.range-row-end[_ngcontent-%COMP%], .nx-calendar-adjacent-cell.range-row-end[_ngcontent-%COMP%]{border-top-right-radius:50%;border-bottom-right-radius:50%}.nx-calendar-body-disabled[_ngcontent-%COMP%]{cursor:default}.nx-calendar-body-cell-content[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:40px;height:40px;margin:0 auto;outline:none;font-size:var(--datefield-cell-font-size);line-height:var(--datefield-cell-line-height);font-weight:var(--datefield-cell-font-weight);letter-spacing:var(--datefield-cell-letter-spacing);color:var(--datefield-cell-color);border-radius:50%;line-height:1;box-shadow:0 0 0 6px transparent}@media screen and (forced-colors: active){.nx-calendar-body-cell-content[_ngcontent-%COMP%]{color:buttonText}}.nx-calendar-body-cell-content[_ngcontent-%COMP%]:focus{z-index:1;position:relative}.nx-calendar-body-cell-content.nx-calendar-body-selected[_ngcontent-%COMP%]{color:var(--datefield-cell-selected-color);background-color:var(--datefield-cell-selected-background-color)}@media screen and (forced-colors: active){.nx-calendar-body-cell-content.nx-calendar-body-selected[_ngcontent-%COMP%]{forced-color-adjust:none;background-color:highlight;color:highlightText}}.nx-calendar-body-cell-content.nx-calendar-body-today[_ngcontent-%COMP%]{color:var(--datefield-controls-color)!important}.nx-calendar-body-cell-content.nx-calendar-body-today[_ngcontent-%COMP%]:after{content:\"\";display:block;position:absolute;width:4px;height:4px;margin-top:24px;background-color:var(--datefield-controls-color);border-radius:50%}@media screen and (forced-colors: active){.nx-calendar-body-cell-content.nx-calendar-body-today[_ngcontent-%COMP%]:after{background-color:CanvasText!important}}.nx-calendar-body-cell-content.nx-calendar-body-today.nx-calendar-body-selected[_ngcontent-%COMP%]{color:var(--datefield-cell-selected-color)!important}.nx-calendar-body-cell-content.nx-calendar-body-today.nx-calendar-body-selected[_ngcontent-%COMP%]:after{background-color:var(--datefield-cell-selected-color)}@media screen and (forced-colors: active){.nx-calendar-body-cell-content.nx-calendar-body-today.nx-calendar-body-selected[_ngcontent-%COMP%]:after{background-color:Background!important}}.nx-calendar-body-disabled[_ngcontent-%COMP%] > .nx-calendar-body-cell-content[_ngcontent-%COMP%]:not(.nx-calendar-body-selected){color:var(--datefield-cell-disabled-color)}@media screen and (forced-colors: active){.nx-calendar-body-disabled[_ngcontent-%COMP%] > .nx-calendar-body-cell-content[_ngcontent-%COMP%]:not(.nx-calendar-body-selected){color:GrayText}}.nx-calendar-body-cell-content.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.nx-calendar-body-cell-content.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}.nx-calendar-body-cell-content[_ngcontent-%COMP%]   .nx-calendar-body-cell-content[_ngcontent-%COMP%]:not(.nx-calendar-body-selected){background-color:var(--datefield-cell-focused-background-color)}@media screen and (forced-colors: active){.nx-calendar-body-cell-content[_ngcontent-%COMP%]   .nx-calendar-body-cell-content[_ngcontent-%COMP%]:not(.nx-calendar-body-selected){background-color:highlight}}.nx-calendar-body-disabled[_ngcontent-%COMP%]{color:var(--datefield-cell-disabled-color)}.nx-calendar-body-disabled.nx-calendar-body-today[_ngcontent-%COMP%]{color:var(--datefield-cell-disabled-today-color)!important}.nx-calendar-body-disabled.nx-calendar-body-today[_ngcontent-%COMP%]:after{background-color:var(--datefield-cell-disabled-today-color)!important}.nx-calendar-body-disabled.nx-calendar-body-today.nx-calendar-body-selected[_ngcontent-%COMP%]:after{background-color:var(--datefield-cell-selected-color)!important}.nx-calendar-body-disabled.nx-calendar-body-selected[_ngcontent-%COMP%]{background-color:var(--datefield-cell-disabled-selected-background-color)!important}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover > .nx-calendar-body-cell-content[_ngcontent-%COMP%], [_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover > .nx-calendar-adjacent-cell-content[_ngcontent-%COMP%]{color:var(--datefield-cell-hover-color);background-color:var(--datefield-cell-hover-background-color)}@media screen and (forced-colors: active){[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover > .nx-calendar-body-cell-content[_ngcontent-%COMP%], [_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover > .nx-calendar-adjacent-cell-content[_ngcontent-%COMP%]{forced-color-adjust:none;background-color:highlight;color:highlightText}}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover > .nx-calendar-body-cell-content.nx-calendar-body-selected[_ngcontent-%COMP%], [_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover > .nx-calendar-adjacent-cell-content.nx-calendar-body-selected[_ngcontent-%COMP%]{color:var(--datefield-cell-selected-color);background-color:var(--datefield-cell-selected-hover-background-color)}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover > .nx-calendar-body-cell-content.nx-calendar-body-selected.nx-calendar-body-today[_ngcontent-%COMP%]:after, [_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover > .nx-calendar-adjacent-cell-content.nx-calendar-body-selected.nx-calendar-body-today[_ngcontent-%COMP%]:after{background-color:var(--datefield-cell-selected-color)}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):hover.in-range > .nx-calendar-body-cell-content[_ngcontent-%COMP%]{background-color:var(--datepicker-range-hover-background-color)}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):active > .nx-calendar-body-cell-content.nx-calendar-body-today[_ngcontent-%COMP%]{color:var(--datefield-cell-active-color)}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):active > .nx-calendar-body-cell-content.nx-calendar-body-today[_ngcontent-%COMP%]:after{background-color:var(--datefield-cell-active-color)}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):active > .nx-calendar-body-cell-content[_ngcontent-%COMP%]:not(.nx-calendar-body-selected){background-color:var(--datefield-cell-active-background-color)}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):active > .nx-calendar-body-cell-content.nx-calendar-body-selected[_ngcontent-%COMP%]{background-color:var(--datefield-cell-selected-active-background-color)}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):active > .nx-calendar-body-cell-content.nx-calendar-body-selected.nx-calendar-body-today[_ngcontent-%COMP%]:after{background-color:var(--datefield-cell-selected-color)}[_ngcontent-%COMP%]:not(.nx-calendar-body-disabled):active.in-range > .nx-calendar-body-cell-content[_ngcontent-%COMP%]{background-color:var(--datepicker-range-active-background-color);color:var(--datefield-cell-selected-color)}.nx-calendar-adjacent-cell-content[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:40px;height:40px;margin:0 auto;font-size:var(--datefield-cell-font-size);line-height:var(--datefield-cell-line-height);font-weight:var(--datefield-cell-font-weight);letter-spacing:var(--datefield-cell-letter-spacing);font-weight:400;color:var(--datefield-cell-disabled-color);border-radius:50%;line-height:1}@media screen and (forced-colors: active){.nx-calendar-adjacent-cell-content[_ngcontent-%COMP%]{color:GrayText}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxCalendarBodyComponent, [{
    type: Component,
    args: [{
      selector: '[nx-calendar-body]',
      host: {
        class: 'nx-calendar-body',
        role: 'grid',
        'attr.aria-readonly': 'true'
      },
      exportAs: 'nxCalendarBody',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [],
      template: "<!-- Create the first and last row separately so we can include special spacer cells. -->\n@for (row of rows; track row[0].value; let rowIndex = $index) {\n<tr role=\"row\">\n    <!--\n    We mark this cell as aria-hidden so it doesn't get read out as one of the days in the week.\n    The aspect ratio of the table cells is maintained by setting the top and bottom padding as a\n    percentage of the width (a variant of the trick described here:\n    https://www.w3schools.com/howto/howto_css_aspect_ratio.asp).\n    -->\n    @if (rowIndex === 0) { @for (items of [].constructor(previousItems); track $index) {\n    <td aria-hidden=\"true\"></td>\n    } } @for (item of row; track item; let colIndex = $index) {\n    <td\n        role=\"gridcell\"\n        class=\"nx-calendar-body-cell\"\n        [style.width.%]=\"100 / numCols\"\n        [class.range-start]=\"selectedValue === item.value && (betweenRange().length > 0 || selectedEndDate() === item.value+1)\"\n        [class.range-end]=\"selectedEndDate() === item.value && (betweenRange().length > 0 || selectedValue === item.value-1)\"\n        [class.in-range]=\"selectedValue !== item.value && selectedEndDate() !== item.value && betweenRange().includes(item.value)\"\n        [class.range-row-start]=\"colIndex === 0 && betweenRange().includes(item.value)\"\n        [class.range-row-end]=\"(colIndex === numCols - 1 || colIndex === row.length-1)  && betweenRange().includes(item.value) \"\n    >\n        <div\n            class=\"nx-calendar-body-cell-content\"\n            [attr.aria-label]=\"item.ariaLabel\"\n            [attr.aria-disabled]=\"!item.enabled || null\"\n            (click)=\"_cellClicked(item)\"\n            (focus)=\"_cellFocused(item)\"\n            (mouseover)=\"_cellFocused(item)\"\n            [tabindex]=\"_isActiveCell(rowIndex, colIndex) ? 0 : -1\"\n            [class.nx-calendar-body-disabled]=\"!item.enabled\"\n            [class.nx-calendar-body-active]=\"_isActiveCell(rowIndex, colIndex)\"\n            [class.nx-calendar-body-selected]=\"selectedValue === item.value || selectedEndDate() === item.value\"\n            [class.nx-calendar-body-today]=\"todayValue === item.value\"\n            role=\"button\"\n            #cell\n        >\n            {{item.displayValue}}\n        </div>\n    </td>\n    } @if (rowIndex === _lastRowIndex && _lastRowOffset) { @for (item of [].constructor(followingItems); track $index) {\n    <td aria-hidden=\"true\"></td>\n    } }\n</tr>\n}\n",
      styles: [".nx-calendar-body-cell,.nx-calendar-adjacent-cell{position:relative;height:0;line-height:0;text-align:center;outline:none;vertical-align:text-bottom;cursor:pointer;border-top:2px;border-top-style:solid;border-top-color:var(--ui-background);border-bottom:2px;border-bottom-style:solid;border-bottom-color:var(--ui-background)}.nx-calendar-body-cell.range-start,.nx-calendar-adjacent-cell.range-start{background-color:var(--datepicker-range-background-color);border-top-left-radius:50%;border-bottom-left-radius:50%}.nx-calendar-body-cell.range-end,.nx-calendar-adjacent-cell.range-end{background-color:var(--datepicker-range-background-color);border-bottom-right-radius:50%;border-top-right-radius:50%}.nx-calendar-body-cell.in-range,.nx-calendar-adjacent-cell.in-range{background-color:var(--datepicker-range-background-color)}.nx-calendar-body-cell.range-row-start,.nx-calendar-adjacent-cell.range-row-start{border-top-left-radius:50%;border-bottom-left-radius:50%}.nx-calendar-body-cell.range-row-end,.nx-calendar-adjacent-cell.range-row-end{border-top-right-radius:50%;border-bottom-right-radius:50%}.nx-calendar-body-disabled{cursor:default}.nx-calendar-body-cell-content{display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:40px;height:40px;margin:0 auto;outline:none;font-size:var(--datefield-cell-font-size);line-height:var(--datefield-cell-line-height);font-weight:var(--datefield-cell-font-weight);letter-spacing:var(--datefield-cell-letter-spacing);color:var(--datefield-cell-color);border-radius:50%;line-height:1;box-shadow:0 0 0 6px transparent}@media screen and (forced-colors: active){.nx-calendar-body-cell-content{color:buttonText}}.nx-calendar-body-cell-content:focus{z-index:1;position:relative}.nx-calendar-body-cell-content.nx-calendar-body-selected{color:var(--datefield-cell-selected-color);background-color:var(--datefield-cell-selected-background-color)}@media screen and (forced-colors: active){.nx-calendar-body-cell-content.nx-calendar-body-selected{forced-color-adjust:none;background-color:highlight;color:highlightText}}.nx-calendar-body-cell-content.nx-calendar-body-today{color:var(--datefield-controls-color)!important}.nx-calendar-body-cell-content.nx-calendar-body-today:after{content:\"\";display:block;position:absolute;width:4px;height:4px;margin-top:24px;background-color:var(--datefield-controls-color);border-radius:50%}@media screen and (forced-colors: active){.nx-calendar-body-cell-content.nx-calendar-body-today:after{background-color:CanvasText!important}}.nx-calendar-body-cell-content.nx-calendar-body-today.nx-calendar-body-selected{color:var(--datefield-cell-selected-color)!important}.nx-calendar-body-cell-content.nx-calendar-body-today.nx-calendar-body-selected:after{background-color:var(--datefield-cell-selected-color)}@media screen and (forced-colors: active){.nx-calendar-body-cell-content.nx-calendar-body-today.nx-calendar-body-selected:after{background-color:Background!important}}.nx-calendar-body-disabled>.nx-calendar-body-cell-content:not(.nx-calendar-body-selected){color:var(--datefield-cell-disabled-color)}@media screen and (forced-colors: active){.nx-calendar-body-disabled>.nx-calendar-body-cell-content:not(.nx-calendar-body-selected){color:GrayText}}.nx-calendar-body-cell-content.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.nx-calendar-body-cell-content.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}.nx-calendar-body-cell-content .nx-calendar-body-cell-content:not(.nx-calendar-body-selected){background-color:var(--datefield-cell-focused-background-color)}@media screen and (forced-colors: active){.nx-calendar-body-cell-content .nx-calendar-body-cell-content:not(.nx-calendar-body-selected){background-color:highlight}}.nx-calendar-body-disabled{color:var(--datefield-cell-disabled-color)}.nx-calendar-body-disabled.nx-calendar-body-today{color:var(--datefield-cell-disabled-today-color)!important}.nx-calendar-body-disabled.nx-calendar-body-today:after{background-color:var(--datefield-cell-disabled-today-color)!important}.nx-calendar-body-disabled.nx-calendar-body-today.nx-calendar-body-selected:after{background-color:var(--datefield-cell-selected-color)!important}.nx-calendar-body-disabled.nx-calendar-body-selected{background-color:var(--datefield-cell-disabled-selected-background-color)!important}:not(.nx-calendar-body-disabled):hover>.nx-calendar-body-cell-content,:not(.nx-calendar-body-disabled):hover>.nx-calendar-adjacent-cell-content{color:var(--datefield-cell-hover-color);background-color:var(--datefield-cell-hover-background-color)}@media screen and (forced-colors: active){:not(.nx-calendar-body-disabled):hover>.nx-calendar-body-cell-content,:not(.nx-calendar-body-disabled):hover>.nx-calendar-adjacent-cell-content{forced-color-adjust:none;background-color:highlight;color:highlightText}}:not(.nx-calendar-body-disabled):hover>.nx-calendar-body-cell-content.nx-calendar-body-selected,:not(.nx-calendar-body-disabled):hover>.nx-calendar-adjacent-cell-content.nx-calendar-body-selected{color:var(--datefield-cell-selected-color);background-color:var(--datefield-cell-selected-hover-background-color)}:not(.nx-calendar-body-disabled):hover>.nx-calendar-body-cell-content.nx-calendar-body-selected.nx-calendar-body-today:after,:not(.nx-calendar-body-disabled):hover>.nx-calendar-adjacent-cell-content.nx-calendar-body-selected.nx-calendar-body-today:after{background-color:var(--datefield-cell-selected-color)}:not(.nx-calendar-body-disabled):hover.in-range>.nx-calendar-body-cell-content{background-color:var(--datepicker-range-hover-background-color)}:not(.nx-calendar-body-disabled):active>.nx-calendar-body-cell-content.nx-calendar-body-today{color:var(--datefield-cell-active-color)}:not(.nx-calendar-body-disabled):active>.nx-calendar-body-cell-content.nx-calendar-body-today:after{background-color:var(--datefield-cell-active-color)}:not(.nx-calendar-body-disabled):active>.nx-calendar-body-cell-content:not(.nx-calendar-body-selected){background-color:var(--datefield-cell-active-background-color)}:not(.nx-calendar-body-disabled):active>.nx-calendar-body-cell-content.nx-calendar-body-selected{background-color:var(--datefield-cell-selected-active-background-color)}:not(.nx-calendar-body-disabled):active>.nx-calendar-body-cell-content.nx-calendar-body-selected.nx-calendar-body-today:after{background-color:var(--datefield-cell-selected-color)}:not(.nx-calendar-body-disabled):active.in-range>.nx-calendar-body-cell-content{background-color:var(--datepicker-range-active-background-color);color:var(--datefield-cell-selected-color)}.nx-calendar-adjacent-cell-content{display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:40px;height:40px;margin:0 auto;font-size:var(--datefield-cell-font-size);line-height:var(--datefield-cell-line-height);font-weight:var(--datefield-cell-font-weight);letter-spacing:var(--datefield-cell-letter-spacing);font-weight:400;color:var(--datefield-cell-disabled-color);border-radius:50%;line-height:1}@media screen and (forced-colors: active){.nx-calendar-adjacent-cell-content{color:GrayText}}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1$1.FocusMonitor
  }], {
    label: [{
      type: Input
    }],
    rows: [{
      type: Input
    }],
    todayValue: [{
      type: Input
    }],
    selectedValue: [{
      type: Input
    }],
    numCols: [{
      type: Input
    }],
    allowDisabledSelection: [{
      type: Input
    }],
    activeCell: [{
      type: Input
    }],
    previousItems: [{
      type: Input
    }],
    followingItems: [{
      type: Input
    }],
    selectedValueChange: [{
      type: Output
    }],
    hoverValueChange: [{
      type: Output
    }],
    selectedValueChangeToPrevious: [{
      type: Output
    }],
    selectedValueChangeToFollowing: [{
      type: Output
    }],
    _cells: [{
      type: ViewChildren,
      args: ['cell']
    }]
  });
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const DAYS_PER_WEEK = 7;
const TOTAL_DAYS_TO_DISPLAY = 6 * DAYS_PER_WEEK;
/**
 * An internal component used to display a single month in the datepicker.
 * @docs-private
 */
class NxMonthViewComponent {
  /**
   * The date to display in this month view (everything other than the month and year is ignored).
   */
  set activeDate(value) {
    const oldActiveDate = this._activeDate;
    const validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
    this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
    if (!this._hasSameMonthAndYear(oldActiveDate, this._activeDate)) {
      this._init();
    }
  }
  get activeDate() {
    return this._activeDate;
  }
  /** The currently selected date. */
  set selected(value) {
    this._selected = this._getValidDateOrNull(value);
    this.selectedDateInMonth.set(this._getDateInCurrentMonth(value?.start || this._selected));
    if (this.isRange()) {
      this.selectedEndDate.set(this._getDateInCurrentMonth(value?.end || this._selected));
      this.betweenRange.set(this.getRangeInMonth(value));
    }
  }
  get selected() {
    return this._selected;
  }
  /** The minimum selectable date. */
  set minDate(value) {
    this._minDate = this._getValidSingleDateOrNull(this._dateAdapter.deserialize(value)); // todo: fix this
  }
  get minDate() {
    return this._minDate;
  }
  /** The maximum selectable date. */
  set maxDate(value) {
    this._maxDate = this._getValidSingleDateOrNull(this._dateAdapter.deserialize(value)); // todo: fix this
  }
  get maxDate() {
    return this._maxDate;
  }
  constructor(_cdr, _dateFormats, _dateAdapter, _dir) {
    this._cdr = _cdr;
    this._dir = _dir;
    this.isRange = input(false);
    /** Emits when a new date is selected. */
    this.selectedChange = new EventEmitter();
    /** Emits when any date is selected. */
    this._userSelection = new EventEmitter();
    /** Emits when any date is activated. */
    this.activeDateChange = new EventEmitter();
    /** Emits when user is hovering on date cell or navigating on date cells by keyboard */
    this.hoverDateChange = new EventEmitter();
    /**
     * The date of the month that the currently selected Date falls on.
     * Null if the currently selected Date is in another month.
     */
    this.selectedDateInMonth = model(null);
    /** The selected end date */
    this.selectedEndDate = model(null);
    /** The range between the selected start and end date */
    this.betweenRange = model([]);
    /** Number of days that should be displayed in one row. */
    this._numCols = 7;
    if (!_dateAdapter) {
      throw createMissingDateImplError('DateAdapter');
    }
    this._dateAdapter = _dateAdapter;
    if (!_dateFormats) {
      throw createMissingDateImplError('MAT_DATE_FORMATS');
    }
    this._dateFormats = _dateFormats;
    const firstDayOfWeek = this._dateAdapter.getFirstDayOfWeek();
    const narrowWeekdays = this._dateAdapter.getDayOfWeekNames('narrow');
    const longWeekdays = this._dateAdapter.getDayOfWeekNames('long');
    // Rotate the labels for days of the week based on the configured first day of the week.
    const weekdays = longWeekdays.map((long, i) => ({
      long,
      narrow: narrowWeekdays[i]
    }));
    this._weekdays = weekdays.slice(firstDayOfWeek).concat(weekdays.slice(0, firstDayOfWeek));
    this._activeDate = this._dateAdapter.today();
  }
  ngAfterContentInit() {
    this._init();
    this._focusActiveCell();
  }
  handleHoverChange(date, monthsToAdd = 0) {
    const selectedYear = this._dateAdapter.getYear(this._dateAdapter.addCalendarMonths(this.activeDate, monthsToAdd));
    const selectedMonth = this._dateAdapter.getMonth(this._dateAdapter.addCalendarMonths(this.activeDate, monthsToAdd));
    const selectedDate = this._dateAdapter.createDate(selectedYear, selectedMonth, date);
    this.hoverDateChange.emit(selectedDate);
  }
  calcDate(date, monthsToAdd = 0) {
    const selectedYear = this._dateAdapter.getYear(this._dateAdapter.addCalendarMonths(this.activeDate, monthsToAdd));
    const selectedMonth = this._dateAdapter.getMonth(this._dateAdapter.addCalendarMonths(this.activeDate, monthsToAdd));
    const selectedDate = this._dateAdapter.createDate(selectedYear, selectedMonth, date);
    return selectedDate;
  }
  /** Handles when a new date is selected. */
  _dateSelected(date, monthsToAdd = 0) {
    if (!this.isRange() && this.selectedDateInMonth() !== date) {
      this.selectedChange.emit(this.calcDate(date, monthsToAdd));
    }
    if (this.isRange()) {
      this.selectedChange.emit(this.calcDate(date, monthsToAdd));
    }
  }
  /** Handles keydown events on the calendar body when calendar is in month view. */
  _handleCalendarBodyKeydown(event) {
    // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
    // disabled ones from being selected. This may not be ideal, we should look into whether
    // navigation should skip over disabled dates, and if so, how to implement that efficiently.
    const oldActiveDate = this._activeDate;
    const isRtl = this._isRtl();
    switch (event.keyCode) {
      case LEFT_ARROW:
        this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? 1 : -1);
        break;
      case RIGHT_ARROW:
        this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? -1 : 1);
        break;
      case UP_ARROW:
        this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -this._numCols);
        break;
      case DOWN_ARROW:
        this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, this._numCols);
        break;
      case HOME:
        this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1 - this._dateAdapter.getDate(this._activeDate));
        break;
      case END:
        this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, this._dateAdapter.getNumDaysInMonth(this._activeDate) - this._dateAdapter.getDate(this._activeDate));
        break;
      case PAGE_UP:
        this.activeDate = event.altKey ? this._dateAdapter.addCalendarYears(this._activeDate, -1) : this._dateAdapter.addCalendarMonths(this._activeDate, -1);
        break;
      case PAGE_DOWN:
        this.activeDate = event.altKey ? this._dateAdapter.addCalendarYears(this._activeDate, 1) : this._dateAdapter.addCalendarMonths(this._activeDate, 1);
        break;
      case ENTER:
      case SPACE:
        if (!this.dateFilter || this.dateFilter(this._activeDate)) {
          this._dateSelected(this._dateAdapter.getDate(this._activeDate));
          // Emit the selected date if the user selected a date. Range will be emitted in _dateSelected method if selection is complete
          if (!this.isRange()) {
            this._userSelection.emit();
          }
          // Prevent unexpected default actions such as form submission.
          event.preventDefault();
        }
        return;
      default:
        // Don't prevent default or focus active cell on keys that we don't explicitly handle.
        return;
    }
    if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
      this.activeDateChange.emit(this.activeDate);
    }
    this._focusActiveCell();
    // Prevent unexpected default actions such as form submission.
    event.preventDefault();
  }
  /** Initializes this month view. */
  _init() {
    const initDateStart = this.selected && this.isRange() ? this.selected.start : this.selected;
    this.selectedDateInMonth.set(this._getDateInCurrentMonth(initDateStart));
    if (this.isRange() && this.selected) {
      this.selectedEndDate.set(this._getDateInCurrentMonth(this.selected?.end || this.selected));
      this.betweenRange.set(this.getRangeInMonth(this.selected));
    }
    this._todayDate = this._getDateInCurrentMonth(this._dateAdapter.today());
    this._monthLabel = this._dateAdapter.getMonthNames('short')[this._dateAdapter.getMonth(this.activeDate)].toLocaleUpperCase();
    const firstOfMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), 1);
    this._firstWeekOffset = (DAYS_PER_WEEK + this._dateAdapter.getDayOfWeek(firstOfMonth) - this._dateAdapter.getFirstDayOfWeek()) % DAYS_PER_WEEK;
    this._createWeekCells();
    this._cdr.markForCheck();
  }
  /** Focuses the active cell after the microtask queue is empty. */
  _focusActiveCell() {
    this._nxCalendarBody._focusActiveCell();
  }
  /** Creates NxCalendarCells for the dates in this month. */
  _createWeekCells() {
    const daysInMonth = this._dateAdapter.getNumDaysInMonth(this.activeDate);
    const dateNames = this._dateAdapter.getDateNames();
    this._weeks = [[]];
    for (let i = 0, cell = this._firstWeekOffset; i < daysInMonth; i++, cell++) {
      if (cell === DAYS_PER_WEEK) {
        this._weeks.push([]);
        cell = 0;
      }
      const date = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), i + 1);
      const enabled = this._shouldEnableDate(date);
      const ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.dateA11yLabel);
      this._weeks[this._weeks.length - 1].push(new NxCalendarCell(i + 1, dateNames[i], ariaLabel, enabled));
    }
  }
  /** Date filter for the month */
  _shouldEnableDate(date) {
    return !!date && (!this.dateFilter || this.dateFilter(date)) && (!this.minDate || this._dateAdapter.compareDate(date, this.minDate) >= 0) && (!this.maxDate || this._dateAdapter.compareDate(date, this.maxDate) <= 0);
  }
  /**
   * Gets the date in this month that the given Date falls on.
   * Returns null if the given Date is in another month.
   */
  _getDateInCurrentMonth(date) {
    const startDate = this.getInitialSelectionDate(date);
    const isInSameMonth = date && this._hasSameMonthAndYear(startDate, this.activeDate);
    return date && isInSameMonth ? this._dateAdapter.getDate(startDate) : null;
  }
  /**
   * Gets the range of dates in this month that the given DateRange falls on.
   * Returns an empty array if the given DateRange is exclusively in another month.
   * @param value The DateRange to check.
   * @returns The range of dates in this month that the DateRange falls on.
   */
  getRangeInMonth(value) {
    const range = (start, end) => Array.from({
      length: end - start + 1
    }, (_, i) => start + i);
    const isCompleteRange = value.start && value.end && this._dateAdapter.isValid(value.start) && this._dateAdapter.isValid(value.end);
    if (!isCompleteRange) {
      return [];
    }
    const isValidRange = this._dateAdapter.compareDate(value.start, value.end) < 0;
    if (!isValidRange) {
      return [];
    }
    const intersectStart = this._hasSameMonthAndYear(value.start, this.activeDate);
    const intersectEnd = this._hasSameMonthAndYear(value.end, this.activeDate);
    if (intersectStart && intersectEnd) {
      const start = this._dateAdapter.getDate(value.start);
      const end = this._dateAdapter.getDate(value.end);
      return range(start + 1, end - 1);
    }
    if (intersectStart && !intersectEnd) {
      const start = this._dateAdapter.getDate(value.start);
      const end = 31;
      return range(start + 1, end);
    }
    if (!intersectStart && intersectEnd) {
      const start = 1;
      const end = this._dateAdapter.getDate(value.end);
      return range(start, end - 1);
    }
    const currentMonthIsLaterThenStart = this._dateAdapter.compareDate(this.activeDate, value.start) > 0;
    const currentMonthIsEarlierThenEnd = this._dateAdapter.compareDate(this.activeDate, value.end) < 0;
    const isBetween = currentMonthIsLaterThenStart && currentMonthIsEarlierThenEnd;
    if (isBetween) {
      return range(1, 31);
    }
    return [];
  }
  /**
   * Gets the date to mark as selected. If the given date is null, it returns today's date
   */
  getInitialSelectionDate(date) {
    if (this._dateAdapter.isDateInstance(date)) {
      return date;
    }
    return date?.start;
  }
  /** Checks whether the 2 dates are non-null and fall within the same month of the same year. */
  _hasSameMonthAndYear(d1, d2) {
    return !!(d1 && d2 && this._dateAdapter.getMonth(d1) === this._dateAdapter.getMonth(d2) && this._dateAdapter.getYear(d1) === this._dateAdapter.getYear(d2));
  }
  /**
   * @param obj The object to check.
   * @returns The given object if it is both a date instance and valid, otherwise null.
   */
  _getValidDateOrNull(obj) {
    if (this.isRange() && !this._dateAdapter.isDateInstance(obj)) {
      const dateRangeObject = obj;
      return {
        start: this._dateAdapter.isDateInstance(dateRangeObject?.start) && this._dateAdapter.isValid(dateRangeObject.start) ? obj.start : null,
        end: this._dateAdapter.isDateInstance(dateRangeObject?.end) && this._dateAdapter.isValid(dateRangeObject.end) ? obj.end : null
      };
    }
    return this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj) ? obj : null;
  }
  _getValidSingleDateOrNull(obj) {
    return this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj) ? obj : null;
  }
  /** Determines whether the user has the RTL layout direction. */
  _isRtl() {
    return this._dir && this._dir.value === 'rtl';
  }
  /**
   * Fill up the last row of the current month
   */
  _getFirstDaysOfFollowingMonth() {
    const followingDaysCount = TOTAL_DAYS_TO_DISPLAY - this._firstWeekOffset - this._dateAdapter.getNumDaysInMonth(this.activeDate);
    const offsetItems = followingDaysCount % 7;
    // If there are any offset items, use them to complete the last row of the current month
    return offsetItems > 0 ? offsetItems : 0;
  }
  /**
   * Returns a row with days, beginning with the date of `firstDayInRow`-parameter.
   * The returned row contains `daysCount` elements.
   */
  _getRowOfDays(firstDayInRow, daysCount) {
    const nextRow = [];
    const dateNames = this._dateAdapter.getDateNames();
    for (let addDays = 0; addDays < daysCount; addDays++) {
      const date = this._dateAdapter.addCalendarDays(firstDayInRow, addDays);
      const day = this._dateAdapter.getDate(date);
      const enabled = this._shouldEnableDate(date);
      const ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.dateA11yLabel);
      nextRow.push(new NxCalendarCell(day, dateNames[day - 1], ariaLabel, enabled));
    }
    return nextRow;
  }
  static {
    this.ɵfac = function NxMonthViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxMonthViewComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NX_DATE_FORMATS, 8), i0.ɵɵdirectiveInject(NxDateAdapter, 8), i0.ɵɵdirectiveInject(i2$1.Directionality, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxMonthViewComponent,
      selectors: [["nx-month-view"]],
      viewQuery: function NxMonthViewComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NxCalendarBodyComponent, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._nxCalendarBody = _t.first);
        }
      },
      inputs: {
        activeDate: "activeDate",
        isRange: [1, "isRange"],
        selected: "selected",
        minDate: "minDate",
        maxDate: "maxDate",
        dateFilter: "dateFilter",
        selectedDateInMonth: [1, "selectedDateInMonth"],
        selectedEndDate: [1, "selectedEndDate"],
        betweenRange: [1, "betweenRange"]
      },
      outputs: {
        selectedChange: "selectedChange",
        _userSelection: "_userSelection",
        activeDateChange: "activeDateChange",
        hoverDateChange: "hoverDateChange",
        selectedDateInMonth: "selectedDateInMonthChange",
        selectedEndDate: "selectedEndDateChange",
        betweenRange: "betweenRangeChange"
      },
      exportAs: ["nxMonthView"],
      decls: 7,
      vars: 10,
      consts: [[1, "nx-calendar-table"], [1, "nx-calendar-table-head"], [1, "nx-calendar-table-header"], ["nx-calendar-body", "", 3, "selectedValueChange", "selectedValueChangeToPrevious", "selectedValueChangeToFollowing", "keydown", "hoverValueChange", "label", "rows", "previousItems", "followingItems", "todayValue", "numCols", "selectedValue", "selectedEndDate", "betweenRange", "activeCell"]],
      template: function NxMonthViewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 0)(1, "thead", 1)(2, "tr");
          i0.ɵɵrepeaterCreate(3, NxMonthViewComponent_For_4_Template, 2, 2, "th", 2, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(5, "tr");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "tbody", 3);
          i0.ɵɵlistener("selectedValueChange", function NxMonthViewComponent_Template_tbody_selectedValueChange_6_listener($event) {
            return ctx._dateSelected($event);
          })("selectedValueChangeToPrevious", function NxMonthViewComponent_Template_tbody_selectedValueChangeToPrevious_6_listener($event) {
            return ctx._dateSelected($event, -1);
          })("selectedValueChangeToFollowing", function NxMonthViewComponent_Template_tbody_selectedValueChangeToFollowing_6_listener($event) {
            return ctx._dateSelected($event, 1);
          })("keydown", function NxMonthViewComponent_Template_tbody_keydown_6_listener($event) {
            return ctx._handleCalendarBodyKeydown($event);
          })("hoverValueChange", function NxMonthViewComponent_Template_tbody_hoverValueChange_6_listener($event) {
            return ctx.handleHoverChange($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵrepeater(ctx._weekdays);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("label", ctx._monthLabel)("rows", ctx._weeks)("previousItems", ctx._firstWeekOffset)("followingItems", ctx._getFirstDaysOfFollowingMonth())("todayValue", ctx._todayDate)("numCols", ctx._numCols)("selectedValue", ctx.selectedDateInMonth())("selectedEndDate", ctx.selectedEndDate())("betweenRange", ctx.betweenRange())("activeCell", ctx._dateAdapter.getDate(ctx.activeDate) - 1);
        }
      },
      dependencies: [NxCalendarBodyComponent],
      styles: [".nx-calendar-table[_ngcontent-%COMP%]{border-spacing:0;border-collapse:collapse;width:100%}.nx-calendar-table-header[_ngcontent-%COMP%]{font-size:var(--datefield-cell-font-size);line-height:var(--datefield-cell-line-height);font-weight:var(--datefield-cell-font-weight);letter-spacing:var(--datefield-cell-letter-spacing);color:var(--datefield-header-cell-color);text-align:center;height:40px;font-weight:var(--datefield-header-cell-font-weight)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxMonthViewComponent, [{
    type: Component,
    args: [{
      selector: 'nx-month-view',
      exportAs: 'nxMonthView',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NxCalendarBodyComponent],
      template: "<table class=\"nx-calendar-table\">\n    <thead class=\"nx-calendar-table-head\">\n        <tr>\n            @for (day of _weekdays; track day) {\n            <th class=\"nx-calendar-table-header\" [attr.aria-label]=\"day.long\">{{day.narrow}}</th>\n            }\n        </tr>\n        <tr></tr>\n    </thead>\n\n    <tbody\n        nx-calendar-body\n        [label]=\"_monthLabel\"\n        [rows]=\"_weeks\"\n        [previousItems]=\"_firstWeekOffset\"\n        [followingItems]=\"_getFirstDaysOfFollowingMonth()\"\n        [todayValue]=\"_todayDate!\"\n        [numCols]=\"_numCols\"\n        [selectedValue]=\"selectedDateInMonth()\"\n        [selectedEndDate]=\"selectedEndDate()\"\n        [betweenRange]=\"betweenRange()\"\n        [activeCell]=\"_dateAdapter.getDate(activeDate) - 1\"\n        (selectedValueChange)=\"_dateSelected($event)\"\n        (selectedValueChangeToPrevious)=\"_dateSelected($event, -1)\"\n        (selectedValueChangeToFollowing)=\"_dateSelected($event, 1)\"\n        (keydown)=\"_handleCalendarBodyKeydown($event)\"\n        (hoverValueChange)=\"handleHoverChange($event)\"\n    ></tbody>\n</table>\n",
      styles: [".nx-calendar-table{border-spacing:0;border-collapse:collapse;width:100%}.nx-calendar-table-header{font-size:var(--datefield-cell-font-size);line-height:var(--datefield-cell-line-height);font-weight:var(--datefield-cell-font-weight);letter-spacing:var(--datefield-cell-letter-spacing);color:var(--datefield-header-cell-color);text-align:center;height:40px;font-weight:var(--datefield-header-cell-font-weight)}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NX_DATE_FORMATS]
    }]
  }, {
    type: NxDateAdapter,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i2$1.Directionality,
    decorators: [{
      type: Optional
    }]
  }], {
    activeDate: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    dateFilter: [{
      type: Input
    }],
    selectedChange: [{
      type: Output
    }],
    _userSelection: [{
      type: Output
    }],
    activeDateChange: [{
      type: Output
    }],
    hoverDateChange: [{
      type: Output
    }],
    _nxCalendarBody: [{
      type: ViewChild,
      args: [NxCalendarBodyComponent, {
        static: true
      }]
    }]
  });
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const yearsPerPage$1 = 20;
const yearsPerRow = 4;
/**
 * An internal component used to display a year selector in the datepicker.
 * @docs-private
 */
class NxMultiYearViewComponent {
  /** The date to display in this multi-year view (everything other than the year is ignored). */
  set activeDate(value) {
    const oldActiveDate = this._activeDate;
    const validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
    this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
    if (Math.floor(this._dateAdapter.getYear(oldActiveDate) / yearsPerPage$1) !== Math.floor(this._dateAdapter.getYear(this._activeDate) / yearsPerPage$1)) {
      this._init();
    }
  }
  get activeDate() {
    return this._activeDate;
  }
  /** The currently selected date. */
  set selected(value) {
    this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
    this._selectedYear = this._selected && this._dateAdapter.getYear(this._selected);
  }
  get selected() {
    return this._selected;
  }
  /** The minimum selectable date. */
  set minDate(value) {
    this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
  }
  get minDate() {
    return this._minDate;
  }
  /** The maximum selectable date. */
  set maxDate(value) {
    this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
  }
  get maxDate() {
    return this._maxDate;
  }
  constructor(_cdr, _dateAdapter, _dir) {
    this._cdr = _cdr;
    this._dir = _dir;
    /** Emits when a new year is selected. */
    this.selectedChange = new EventEmitter();
    /** Emits the selected year. This doesn't imply a change on the selected date */
    this.yearSelected = new EventEmitter();
    /** Emits when any date is activated. */
    this.activeDateChange = new EventEmitter();
    if (!_dateAdapter) {
      throw createMissingDateImplError('DateAdapter');
    }
    this._dateAdapter = _dateAdapter;
    this._activeDate = this._dateAdapter.today();
  }
  ngAfterContentInit() {
    this._init();
    this._focusActiveCell();
  }
  /** Initializes this multi-year view. */
  _init() {
    this._todayYear = this._dateAdapter.getYear(this._dateAdapter.today());
    const activeYear = this._dateAdapter.getYear(this._activeDate);
    const activeOffset = activeYear % yearsPerPage$1;
    this._years = [];
    for (let i = 0, row = []; i < yearsPerPage$1; i++) {
      row.push(activeYear - activeOffset + i);
      if (row.length === yearsPerRow) {
        this._years.push(row.map(year => this._createCellForYear(year)));
        row = [];
      }
    }
    this._cdr.markForCheck();
  }
  /** Handles when a new year is selected. */
  _yearSelected(year) {
    this.yearSelected.emit(this._dateAdapter.createDate(year, 0, 1));
    const month = this._dateAdapter.getMonth(this.activeDate);
    const daysInMonth = this._dateAdapter.getNumDaysInMonth(this._dateAdapter.createDate(year, month, 1));
    this.selectedChange.emit(this._dateAdapter.createDate(year, month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
  }
  /** Handles keydown events on the calendar body when calendar is in multi-year view. */
  _handleCalendarBodyKeydown(event) {
    // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
    // disabled ones from being selected. This may not be ideal, we should look into whether
    // navigation should skip over disabled dates, and if so, how to implement that efficiently.
    const oldActiveDate = this._activeDate;
    const isRtl = this._isRtl();
    switch (event.keyCode) {
      case LEFT_ARROW:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, isRtl ? 1 : -1);
        break;
      case RIGHT_ARROW:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, isRtl ? -1 : 1);
        break;
      case UP_ARROW:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -yearsPerRow);
        break;
      case DOWN_ARROW:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerRow);
        break;
      case HOME:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -this._dateAdapter.getYear(this._activeDate) % yearsPerPage$1);
        break;
      case END:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerPage$1 - this._dateAdapter.getYear(this._activeDate) % yearsPerPage$1 - 1);
        break;
      case PAGE_UP:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -yearsPerPage$1 * 10 : -yearsPerPage$1);
        break;
      case PAGE_DOWN:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? yearsPerPage$1 * 10 : yearsPerPage$1);
        break;
      case ENTER:
        this._yearSelected(this._dateAdapter.getYear(this._activeDate));
        break;
      default:
        // Don't prevent default or focus active cell on keys that we don't explicitly handle.
        return;
    }
    if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
      this.activeDateChange.emit(this.activeDate);
    }
    this._focusActiveCell();
    // Prevent unexpected default actions such as form submission.
    event.preventDefault();
  }
  _getActiveCell() {
    return this._dateAdapter.getYear(this.activeDate) % yearsPerPage$1;
  }
  /** Focuses the active cell after the microtask queue is empty. */
  _focusActiveCell() {
    this._nxCalendarBody._focusActiveCell();
  }
  /** Creates an NxCalendarCell for the given year. */
  _createCellForYear(year) {
    const yearName = this._dateAdapter.getYearName(this._dateAdapter.createDate(year, 0, 1));
    return new NxCalendarCell(year, yearName, yearName, this._shouldEnableYear(year));
  }
  /** Whether the given year is enabled. */
  _shouldEnableYear(year) {
    // disable if the year is greater than maxDate lower than minDate
    if (year === undefined || year === null || this.maxDate && year > this._dateAdapter.getYear(this.maxDate) || this.minDate && year < this._dateAdapter.getYear(this.minDate)) {
      return false;
    }
    // enable if it reaches here and there's no filter defined
    if (!this.dateFilter) {
      return true;
    }
    const firstOfYear = this._dateAdapter.createDate(year, 0, 1);
    // If any date in the year is enabled count the year as enabled.
    for (let date = firstOfYear; this._dateAdapter.getYear(date) === year; date = this._dateAdapter.addCalendarDays(date, 1)) {
      if (this.dateFilter(date)) {
        return true;
      }
    }
    return false;
  }
  /**
   * @param obj The object to check.
   * @returns The given object if it is both a date instance and valid, otherwise null.
   */
  _getValidDateOrNull(obj) {
    return this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj) ? obj : null;
  }
  /** Determines whether the user has the RTL layout direction. */
  _isRtl() {
    return this._dir && this._dir.value === 'rtl';
  }
  static {
    this.ɵfac = function NxMultiYearViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxMultiYearViewComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NxDateAdapter, 8), i0.ɵɵdirectiveInject(i2$1.Directionality, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxMultiYearViewComponent,
      selectors: [["nx-multi-year-view"]],
      viewQuery: function NxMultiYearViewComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NxCalendarBodyComponent, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._nxCalendarBody = _t.first);
        }
      },
      inputs: {
        activeDate: "activeDate",
        selected: "selected",
        minDate: "minDate",
        maxDate: "maxDate",
        dateFilter: "dateFilter"
      },
      outputs: {
        selectedChange: "selectedChange",
        yearSelected: "yearSelected",
        activeDateChange: "activeDateChange"
      },
      exportAs: ["nxMultiYearView"],
      decls: 2,
      vars: 5,
      consts: [[1, "nx-calendar-table"], ["nx-calendar-body", "", 3, "selectedValueChange", "keydown", "rows", "todayValue", "selectedValue", "numCols", "activeCell"]],
      template: function NxMultiYearViewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 0)(1, "tbody", 1);
          i0.ɵɵlistener("selectedValueChange", function NxMultiYearViewComponent_Template_tbody_selectedValueChange_1_listener($event) {
            return ctx._yearSelected($event);
          })("keydown", function NxMultiYearViewComponent_Template_tbody_keydown_1_listener($event) {
            return ctx._handleCalendarBodyKeydown($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("rows", ctx._years)("todayValue", ctx._todayYear)("selectedValue", ctx._selectedYear)("numCols", 4)("activeCell", ctx._getActiveCell());
        }
      },
      dependencies: [NxCalendarBodyComponent],
      styles: [".nx-calendar-table[_ngcontent-%COMP%]{border-spacing:0;border-collapse:collapse;width:100%}[_nghost-%COMP%]     .nx-calendar-body .nx-calendar-body-cell-content{margin:0 17.3333333333px 8px}@media (max-width: 703px){[_nghost-%COMP%]     .nx-calendar-body .nx-calendar-body-cell-content{margin:0 12px 8px}}[_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-left:8px}@media (max-width: 703px){[_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-left:16px}}[dir=rtl]   [_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-right:8px;margin-left:17.3333333333px}@media (max-width: 703px){[dir=rtl]   [_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-right:12px;margin-left:12px}}[_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:8px}@media (max-width: 703px){[_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:16px}}[dir=rtl]   [_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:17.3333333333px;margin-left:8px}@media (max-width: 703px){[dir=rtl]   [_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:12px;margin-left:12px}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxMultiYearViewComponent, [{
    type: Component,
    args: [{
      selector: 'nx-multi-year-view',
      exportAs: 'nxMultiYearView',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NxCalendarBodyComponent],
      template: "<table class=\"nx-calendar-table\">\n    <tbody\n        nx-calendar-body\n        [rows]=\"_years\"\n        [todayValue]=\"_todayYear\"\n        [selectedValue]=\"_selectedYear!\"\n        [numCols]=\"4\"\n        [activeCell]=\"_getActiveCell()\"\n        (selectedValueChange)=\"_yearSelected($event)\"\n        (keydown)=\"_handleCalendarBodyKeydown($event)\"\n    ></tbody>\n</table>\n",
      styles: [".nx-calendar-table{border-spacing:0;border-collapse:collapse;width:100%}:host ::ng-deep .nx-calendar-body .nx-calendar-body-cell-content{margin:0 17.3333333333px 8px}@media (max-width: 703px){:host ::ng-deep .nx-calendar-body .nx-calendar-body-cell-content{margin:0 12px 8px}}:host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-left:8px}@media (max-width: 703px){:host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-left:16px}}[dir=rtl] :host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-right:8px;margin-left:17.3333333333px}@media (max-width: 703px){[dir=rtl] :host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-right:12px;margin-left:12px}}:host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:8px}@media (max-width: 703px){:host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:16px}}[dir=rtl] :host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:17.3333333333px;margin-left:8px}@media (max-width: 703px){[dir=rtl] :host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:12px;margin-left:12px}}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: NxDateAdapter,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i2$1.Directionality,
    decorators: [{
      type: Optional
    }]
  }], {
    activeDate: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    dateFilter: [{
      type: Input
    }],
    selectedChange: [{
      type: Output
    }],
    yearSelected: [{
      type: Output
    }],
    activeDateChange: [{
      type: Output
    }],
    _nxCalendarBody: [{
      type: ViewChild,
      args: [NxCalendarBodyComponent, {
        static: true
      }]
    }]
  });
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An internal component used to display a single year in the datepicker.
 * @docs-private
 */
class NxYearViewComponent {
  /** The date to display in this year view (everything other than the year is ignored). */
  set activeDate(value) {
    const oldActiveDate = this._activeDate;
    const validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
    this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
    if (this._dateAdapter.getYear(oldActiveDate) !== this._dateAdapter.getYear(this._activeDate)) {
      this._init();
    }
  }
  get activeDate() {
    return this._activeDate;
  }
  /** The currently selected date. */
  set selected(value) {
    this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
    this._selectedMonth = this._getMonthInCurrentYear(this._selected);
  }
  get selected() {
    return this._selected;
  }
  /** The minimum selectable date. */
  set minDate(value) {
    this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
  }
  get minDate() {
    return this._minDate;
  }
  /** The maximum selectable date. */
  set maxDate(value) {
    this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
  }
  get maxDate() {
    return this._maxDate;
  }
  constructor(_cdr, _dateFormats, _dateAdapter, _dir) {
    this._cdr = _cdr;
    this._dir = _dir;
    this.isRange = input(false);
    /** Emits when a new month is selected. */
    this.selectedChange = new EventEmitter();
    /** Emits the selected month. This doesn't imply a change on the selected date */
    this.monthSelected = new EventEmitter();
    /** Emits when any date is activated. */
    this.activeDateChange = new EventEmitter();
    this._numCols = 3;
    if (!_dateAdapter) {
      throw createMissingDateImplError('DateAdapter');
    }
    this._dateAdapter = _dateAdapter;
    if (!_dateFormats) {
      throw createMissingDateImplError('MAT_DATE_FORMATS');
    }
    this._dateFormats = _dateFormats;
    this._activeDate = this._dateAdapter.today();
  }
  ngAfterContentInit() {
    this._init();
    this._focusActiveCell();
  }
  /** Handles when a new month is selected. */
  _monthSelected(month) {
    const normalizedDate = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
    this.monthSelected.emit(normalizedDate);
    const daysInMonth = this._dateAdapter.getNumDaysInMonth(normalizedDate);
    this.selectedChange.emit(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
  }
  /** Handles keydown events on the calendar body when calendar is in year view. */
  _handleCalendarBodyKeydown(event) {
    // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
    // disabled ones from being selected. This may not be ideal, we should look into whether
    // navigation should skip over disabled dates, and if so, how to implement that efficiently.
    const oldActiveDate = this._activeDate;
    const isRtl = this._isRtl();
    switch (event.keyCode) {
      case LEFT_ARROW:
        this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? 1 : -1);
        break;
      case RIGHT_ARROW:
        this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? -1 : 1);
        break;
      case UP_ARROW:
        this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._numCols);
        break;
      case DOWN_ARROW:
        this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, this._numCols);
        break;
      case HOME:
        this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._dateAdapter.getMonth(this._activeDate));
        break;
      case END:
        this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 11 - this._dateAdapter.getMonth(this._activeDate));
        break;
      case PAGE_UP:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -10 : -1);
        break;
      case PAGE_DOWN:
        this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? 10 : 1);
        break;
      case ENTER:
        this._monthSelected(this._dateAdapter.getMonth(this._activeDate));
        break;
      default:
        // Don't prevent default or focus active cell on keys that we don't explicitly handle.
        return;
    }
    if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
      this.activeDateChange.emit(this.activeDate);
    }
    this._focusActiveCell();
    // Prevent unexpected default actions such as form submission.
    event.preventDefault();
  }
  /** Initializes this year view. */
  _init() {
    const initDate = this.selected && this.isRange() ? this.selected.start : this.selected;
    this._selectedMonth = this._getMonthInCurrentYear(initDate);
    this._todayMonth = this._getMonthInCurrentYear(this._dateAdapter.today());
    this._yearLabel = this._dateAdapter.getYearName(this.activeDate);
    const monthNames = this._dateAdapter.getMonthNames('short');
    this._months = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]].map(row => row.map(month => this._createCellForMonth(month, monthNames[month])));
    this._cdr.markForCheck();
  }
  /** Focuses the active cell after the microtask queue is empty. */
  _focusActiveCell() {
    this._nxCalendarBody._focusActiveCell();
  }
  /**
   * Gets the month in this year that the given Date falls on.
   * Returns null if the given Date is in another year.
   */
  _getMonthInCurrentYear(date) {
    return date && this._dateAdapter.getYear(date) === this._dateAdapter.getYear(this.activeDate) ? this._dateAdapter.getMonth(date) : null;
  }
  /** Creates an NxCalendarCell for the given month. */
  _createCellForMonth(month, monthName) {
    const ariaLabel = this._dateAdapter.format(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1), this._dateFormats.display.monthYearA11yLabel);
    return new NxCalendarCell(month, monthName, ariaLabel, this._shouldEnableMonth(month));
  }
  /** Whether the given month is enabled. */
  _shouldEnableMonth(month) {
    const activeYear = this._dateAdapter.getYear(this.activeDate);
    if (month === undefined || month === null || this._isYearAndMonthAfterMaxDate(activeYear, month) || this._isYearAndMonthBeforeMinDate(activeYear, month)) {
      return false;
    }
    if (!this.dateFilter) {
      return true;
    }
    const firstOfMonth = this._dateAdapter.createDate(activeYear, month, 1);
    // If any date in the month is enabled count the month as enabled.
    for (let date = firstOfMonth; this._dateAdapter.getMonth(date) === month; date = this._dateAdapter.addCalendarDays(date, 1)) {
      if (this.dateFilter(date)) {
        return true;
      }
    }
    return false;
  }
  /**
   * Tests whether the combination month/year is after this.maxDate, considering just the month and year of this.maxDate.
   */
  _isYearAndMonthAfterMaxDate(year, month) {
    if (this.maxDate) {
      const maxYear = this._dateAdapter.getYear(this.maxDate);
      const maxMonth = this._dateAdapter.getMonth(this.maxDate);
      return year > maxYear || year === maxYear && month > maxMonth;
    }
    return false;
  }
  /**
   * Tests whether the combination month/year is before this.minDate, considering just the month and year of this.minDate.
   */
  _isYearAndMonthBeforeMinDate(year, month) {
    if (this.minDate) {
      const minYear = this._dateAdapter.getYear(this.minDate);
      const minMonth = this._dateAdapter.getMonth(this.minDate);
      return year < minYear || year === minYear && month < minMonth;
    }
    return false;
  }
  /**
   * @param obj The object to check.
   * @returns The given object if it is both a date instance and valid, otherwise null.
   */
  _getValidDateOrNull(obj) {
    return this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj) ? obj : null;
  }
  /** Determines whether the user has the RTL layout direction. */
  _isRtl() {
    return this._dir && this._dir.value === 'rtl';
  }
  static {
    this.ɵfac = function NxYearViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxYearViewComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NX_DATE_FORMATS, 8), i0.ɵɵdirectiveInject(NxDateAdapter, 8), i0.ɵɵdirectiveInject(i2$1.Directionality, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxYearViewComponent,
      selectors: [["nx-year-view"]],
      viewQuery: function NxYearViewComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NxCalendarBodyComponent, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._nxCalendarBody = _t.first);
        }
      },
      inputs: {
        isRange: [1, "isRange"],
        activeDate: "activeDate",
        selected: "selected",
        minDate: "minDate",
        maxDate: "maxDate",
        dateFilter: "dateFilter"
      },
      outputs: {
        selectedChange: "selectedChange",
        monthSelected: "monthSelected",
        activeDateChange: "activeDateChange"
      },
      exportAs: ["nxYearView"],
      decls: 2,
      vars: 6,
      consts: [[1, "nx-calendar-table"], ["nx-calendar-body", "", 3, "selectedValueChange", "keydown", "label", "rows", "todayValue", "selectedValue", "numCols", "activeCell"]],
      template: function NxYearViewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 0)(1, "tbody", 1);
          i0.ɵɵlistener("selectedValueChange", function NxYearViewComponent_Template_tbody_selectedValueChange_1_listener($event) {
            return ctx._monthSelected($event);
          })("keydown", function NxYearViewComponent_Template_tbody_keydown_1_listener($event) {
            return ctx._handleCalendarBodyKeydown($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("label", ctx._yearLabel)("rows", ctx._months)("todayValue", ctx._todayMonth)("selectedValue", ctx._selectedMonth)("numCols", ctx._numCols)("activeCell", ctx._dateAdapter.getMonth(ctx.activeDate));
        }
      },
      dependencies: [NxCalendarBodyComponent],
      styles: [".nx-calendar-table[_ngcontent-%COMP%]{border-spacing:0;border-collapse:collapse;width:100%}[_nghost-%COMP%]     .nx-calendar-body .nx-calendar-body-cell-content{margin:0 36px 8px}@media (max-width: 703px){[_nghost-%COMP%]     .nx-calendar-body .nx-calendar-body-cell-content{margin:0 24px 8px}}[_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-left:8px}@media (max-width: 703px){[_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-left:24px}}[dir=rtl]   [_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-right:8px;margin-left:36px}@media (max-width: 703px){[dir=rtl]   [_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-right:24px;margin-left:24px}}[_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:8px}@media (max-width: 703px){[_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:24px}}[dir=rtl]   [_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:36px;margin-left:8px}@media (max-width: 703px){[dir=rtl]   [_nghost-%COMP%]     .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:24px;margin-left:24px}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxYearViewComponent, [{
    type: Component,
    args: [{
      selector: 'nx-year-view',
      exportAs: 'nxYearView',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NxCalendarBodyComponent],
      template: "<table class=\"nx-calendar-table\">\n    <tbody\n        nx-calendar-body\n        [label]=\"_yearLabel\"\n        [rows]=\"_months\"\n        [todayValue]=\"_todayMonth!\"\n        [selectedValue]=\"_selectedMonth!\"\n        [numCols]=\"_numCols\"\n        [activeCell]=\"_dateAdapter.getMonth(activeDate)\"\n        (selectedValueChange)=\"_monthSelected($event)\"\n        (keydown)=\"_handleCalendarBodyKeydown($event)\"\n    ></tbody>\n</table>\n",
      styles: [".nx-calendar-table{border-spacing:0;border-collapse:collapse;width:100%}:host ::ng-deep .nx-calendar-body .nx-calendar-body-cell-content{margin:0 36px 8px}@media (max-width: 703px){:host ::ng-deep .nx-calendar-body .nx-calendar-body-cell-content{margin:0 24px 8px}}:host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-left:8px}@media (max-width: 703px){:host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-left:24px}}[dir=rtl] :host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-right:8px;margin-left:36px}@media (max-width: 703px){[dir=rtl] :host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:first-child .nx-calendar-body-cell-content{margin-right:24px;margin-left:24px}}:host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:8px}@media (max-width: 703px){:host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:24px}}[dir=rtl] :host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:36px;margin-left:8px}@media (max-width: 703px){[dir=rtl] :host ::ng-deep .nx-calendar-body tr .nx-calendar-body-cell:last-child .nx-calendar-body-cell-content{margin-right:24px;margin-left:24px}}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NX_DATE_FORMATS]
    }]
  }, {
    type: NxDateAdapter,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i2$1.Directionality,
    decorators: [{
      type: Optional
    }]
  }], {
    activeDate: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    dateFilter: [{
      type: Input
    }],
    selectedChange: [{
      type: Output
    }],
    monthSelected: [{
      type: Output
    }],
    activeDateChange: [{
      type: Output
    }],
    _nxCalendarBody: [{
      type: ViewChild,
      args: [NxCalendarBodyComponent, {
        static: true
      }]
    }]
  });
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Datepicker data that requires internationalization. */
class NxDatepickerIntl {
  constructor() {
    /**
     * Stream that emits whenever the labels here are changed. Use this to notify
     * components if the labels have changed after initialization.
     */
    this.changes = new Subject();
    /** A label for the calendar popup (used by screen readers). */
    this.calendarLabel = 'Calendar';
    /** A label for the button used to open the calendar popup (used by screen readers). */
    this.openCalendarLabel = 'Open calendar';
    /** A label for the button used to close the calendar popup (used by screen readers). */
    this.closeIconLabel = 'Close calendar';
    /** A label for the previous month button (used by screen readers). */
    this.prevMonthLabel = 'Previous month';
    /** A label for the next month button (used by screen readers). */
    this.nextMonthLabel = 'Next month';
    /** A label for the previous year button (used by screen readers). */
    this.prevYearLabel = 'Previous year';
    /** A label for the next year button (used by screen readers). */
    this.nextYearLabel = 'Next year';
    /** A label for the previous multi-year button (used by screen readers). */
    this.prevMultiYearLabel = 'Previous 20 years';
    /** A label for the next multi-year button (used by screen readers). */
    this.nextMultiYearLabel = 'Next 20 years';
    /** A label for the 'switch to month view' button (used by screen readers). */
    this.switchToMonthViewLabel = 'Choose date';
    /** A label for the 'switch to year view' button (used by screen readers). */
    this.switchToMultiYearViewLabel = 'Choose month and year';
    /** A label for the today button (used by screen readers). */
    this.todayButtonLabel = 'Today';
    /** A label for describe the today button (used by screen readers). */
    this.todayButtonAriaLabel = 'Navigate to today';
    /** Announcement message after start date was selected (used by screen readers) */
    this.startDateSelectedAnnouncement = 'Start date selected. Please Select end date.';
    /** Announcement message after date range selection is completed (used by screen readers) */
    this.dateRangeSelectionCompleteAnnouncement = 'Date range selection complete.';
  }
  static {
    this.ɵfac = function NxDatepickerIntl_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDatepickerIntl)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NxDatepickerIntl,
      factory: NxDatepickerIntl.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDatepickerIntl, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const yearsPerPage = 20;
/**
 * A calendar that is used as part of the datepicker.
 * @docs-private
 */
class NxCalendarComponent {
  /** A date representing the period (month or year) to start the calendar in. */
  set startAt(value) {
    this._startAt = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
  }
  get startAt() {
    return this._startAt;
  }
  /** The currently selected date. */
  set selected(value) {
    if (this.isRange()) {
      this._selected.set(this.getValidRangeOrNullDate(value));
    } else {
      this._selected.set(this._getValidDateOrNull(value));
    }
  }
  get selected() {
    return this._selected();
  }
  /** The minimum selectable date. */
  set minDate(value) {
    this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
  }
  get minDate() {
    return this._minDate;
  }
  /** The maximum selectable date. */
  set maxDate(value) {
    this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
  }
  get maxDate() {
    return this._maxDate;
  }
  /**
   * The current active date. This determines which time period is shown and which date is
   * highlighted when using keyboard navigation.
   */
  set _activeDate(value) {
    this._clampedActiveDate = this._dateAdapter.clampDate(value, this.minDate, this.maxDate);
  }
  get _activeDate() {
    return this._clampedActiveDate;
  }
  /** The label for the current calendar view. */
  get _periodButtonText() {
    if (this._currentView === 'month') {
      return this._dateAdapter.format(this._activeDate, this._dateFormats.display.monthYearLabel);
    }
    if (this._currentView === 'year') {
      return this._dateAdapter.getYearName(this._activeDate);
    }
    const activeYear = this._dateAdapter.getYear(this._activeDate);
    const firstYearInView = this._dateAdapter.getYearName(this._dateAdapter.createDate(activeYear - activeYear % yearsPerPage, 0, 1));
    const lastYearInView = this._dateAdapter.getYearName(this._dateAdapter.createDate(activeYear + yearsPerPage - 1 - activeYear % yearsPerPage, 0, 1));
    return `${firstYearInView} \u2013 ${lastYearInView}`;
  }
  get _periodButtonLabel() {
    return this._currentView === 'month' ? this._intl.switchToMultiYearViewLabel : this._intl.switchToMonthViewLabel;
  }
  /** The label for the the previous button. */
  get _prevButtonLabel() {
    return {
      month: this._intl.prevMonthLabel,
      year: this._intl.prevYearLabel,
      'multi-year': this._intl.prevMultiYearLabel
    }[this._currentView];
  }
  /** The label for the the next button. */
  get _nextButtonLabel() {
    return {
      month: this._intl.nextMonthLabel,
      year: this._intl.nextYearLabel,
      'multi-year': this._intl.nextMultiYearLabel
    }[this._currentView];
  }
  get _isRtl() {
    return this._dir?.value === 'rtl';
  }
  /** Check whether today button should disable or not */
  get _disableTodayButton() {
    const today = this._dateAdapter.today();
    return this._currentView === 'month' && this._dateAdapter.getMonth(this._activeDate) === this._dateAdapter.getMonth(today) && this._dateAdapter.getYear(this._activeDate) === this._dateAdapter.getYear(today);
  }
  constructor(_intl, _dateAdapter, _dir, _dateFormats, _cdr, _focusMonitor, _liveAnnouncer, _elementRef) {
    this._intl = _intl;
    this._dir = _dir;
    this._focusMonitor = _focusMonitor;
    this._liveAnnouncer = _liveAnnouncer;
    this._elementRef = _elementRef;
    /** Whether the datepicker should be in date range selection mode */
    this.isRange = input(false);
    /** Whether the calendar should be started in month or year view. */
    this.startView = 'month';
    this._selected = signal(null);
    /** Internal state for improved typesafety */
    this._currentRange = {
      start: null,
      end: null
    };
    this._inEndDateSelectionMode = false;
    /** Determines whether the today button is displayed in the calendar. */
    this.showTodayButton = false;
    /** Emits when the currently selected date changes. */
    this.selectedChange = new EventEmitter();
    /**
     * Emits the year chosen in multiyear view.
     * This doesn't imply a change on the selected date.
     */
    this.yearSelected = new EventEmitter();
    /**
     * Emits the month chosen in year view.
     * This doesn't imply a change on the selected date.
     */
    this.monthSelected = new EventEmitter();
    /** Emits when any date is selected. */
    this._userSelection = new EventEmitter();
    /**
     * Emits when the Today button is clicked.
     * This doesn't imply a change on the selected date.
     */
    this.todayButtonClick = new EventEmitter();
    this._injector = inject(Injector);
    this._destroyed = new Subject();
    if (!_dateAdapter) {
      throw createMissingDateImplError('DateAdapter');
    }
    this._dateAdapter = _dateAdapter;
    if (!_dateFormats) {
      throw createMissingDateImplError('MAT_DATE_FORMATS');
    }
    this._dateFormats = _dateFormats;
    _intl.changes.pipe(takeUntil(this._destroyed)).subscribe(() => _cdr.markForCheck());
  }
  ngAfterContentInit() {
    this._activeDate = this.startAt || this._dateAdapter.today();
    this._currentView = this.startView;
  }
  ngAfterViewInit() {
    this._focusMonitor.monitor(this._previousButton);
    this._focusMonitor.monitor(this._nextButton);
    this._focusMonitor.monitor(this._changeViewButton);
    if (this._todayButton) {
      this._focusMonitor.monitor(this._todayButton);
    }
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this._focusMonitor.stopMonitoring(this._previousButton);
    this._focusMonitor.stopMonitoring(this._nextButton);
    this._focusMonitor.stopMonitoring(this._changeViewButton);
    if (this._todayButton) {
      this._focusMonitor.stopMonitoring(this._todayButton);
    }
  }
  ngOnChanges(changes) {
    const change = changes.minDate || changes.maxDate || changes.dateFilter;
    if (change && !change.firstChange) {
      const view = this.monthView || this.yearView || this.multiYearView;
      if (view) {
        view._init();
      }
    }
  }
  _hoverDateChange(date) {
    this._inEndDateSelectionMode = true;
    if (this.isRange() && this._currentRange.start) {
      this._currentRange = {
        start: this._currentRange.start,
        end: date
      };
      this._selected.set(this._currentRange);
    }
  }
  /** Handles date selection in the month view. */
  _dateSelected(date) {
    if (!this.isRange() && !this._dateAdapter.sameDate(date, this.selected)) {
      this.selected = date;
      this.selectedChange.emit(date);
      this._userSelected();
      return;
    }
    const selectedDate = this._getValidDateOrNull(date);
    if (!selectedDate) {
      return;
    }
    // first step for range selection - select start date
    if (this.isRange() && !this._currentRange.start) {
      this._currentRange = {
        start: selectedDate,
        end: null
      };
      this._selected.set(this._currentRange);
      this._liveAnnouncer.announce(this._intl.startDateSelectedAnnouncement);
      this.selectedChange.emit(this.selected);
      return;
    }
    // case start date is selected but the next date is before the start date -> reset start date
    if (this.isRange() && this._currentRange.start && this._dateAdapter.compareDate(selectedDate, this._currentRange.start) < 0) {
      this._currentRange = {
        start: selectedDate,
        end: null
      };
      this._selected.set(this._currentRange);
      this.selectedChange.emit(this.selected);
      return;
    }
    // final case - if start date is selected and the next date is after the start date -> select end date
    if (this.isRange() && this._currentRange.start && (!this._currentRange.end || this._inEndDateSelectionMode)) {
      this._currentRange = {
        start: this._currentRange.start,
        end: selectedDate
      };
      this._selected.set(this._currentRange);
      this._liveAnnouncer.announce(this._intl.dateRangeSelectionCompleteAnnouncement);
      this.selectedChange.emit(this.selected);
      this._userSelected();
    }
  }
  /** Handles year selection in the multiyear view. */
  _yearSelectedInMultiYearView(normalizedYear) {
    this.yearSelected.emit(normalizedYear);
  }
  /** Handles month selection in the year view. */
  _monthSelectedInYearView(normalizedMonth) {
    this.monthSelected.emit(normalizedMonth);
  }
  _userSelected() {
    if (!this.isRange()) {
      this._userSelection.emit();
    }
    const range = this.selected;
    if (this.isRange() && range.start && range.end) {
      this._userSelection.emit();
    }
  }
  /** Handles year/month selection in the multi-year/year views. */
  _goToDateInView(date, view) {
    this._activeDate = date;
    this._currentView = view;
  }
  /** Handles user clicks on the period label. */
  _changeViewClicked() {
    this._currentView = this._currentView === 'month' ? 'multi-year' : 'month';
  }
  /** Handles user clicks on the previous button. */
  _previousClicked() {
    this._activeDate = this._currentView === 'month' ? this._dateAdapter.addCalendarMonths(this._activeDate, -1) : this._dateAdapter.addCalendarYears(this._activeDate, this._currentView === 'year' ? -1 : -yearsPerPage);
  }
  /** Handles user clicks on the next button. */
  _nextClicked() {
    this._activeDate = this._currentView === 'month' ? this._dateAdapter.addCalendarMonths(this._activeDate, 1) : this._dateAdapter.addCalendarYears(this._activeDate, this._currentView === 'year' ? 1 : yearsPerPage);
  }
  /** Whether the previous period button is enabled. */
  _previousEnabled() {
    if (!this.minDate) {
      return true;
    }
    return !this.minDate || !this._isSameView(this._activeDate, this.minDate);
  }
  /** Whether the next period button is enabled. */
  _nextEnabled() {
    return !this.maxDate || !this._isSameView(this._activeDate, this.maxDate);
  }
  /** Whether the two dates represent the same view in the current view mode (month or year). */
  _isSameView(date1, date2) {
    if (this._currentView === 'month') {
      return this._dateAdapter.getYear(date1) === this._dateAdapter.getYear(date2) && this._dateAdapter.getMonth(date1) === this._dateAdapter.getMonth(date2);
    }
    if (this._currentView === 'year') {
      return this._dateAdapter.getYear(date1) === this._dateAdapter.getYear(date2);
    }
    // Otherwise we are in 'multi-year' view.
    return Math.floor(this._dateAdapter.getYear(date1) / yearsPerPage) === Math.floor(this._dateAdapter.getYear(date2) / yearsPerPage);
  }
  /**
   * @param obj The object to check.
   * @returns The given object if it is both a date instance and valid, otherwise null.
   */
  _getValidDateOrNull(obj) {
    const returnDate = this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj) ? obj : null;
    return returnDate;
  }
  getValidRangeOrNullDate(newDate) {
    if (newDate === null) {
      return {
        start: null,
        end: null
      };
    }
    const newDateRange = newDate;
    const isStartValid = this._dateAdapter.isDateInstance(newDateRange?.start) && this._dateAdapter.isValid(newDateRange.start);
    const isEndValid = this._dateAdapter.isDateInstance(newDateRange?.end) && this._dateAdapter.isValid(newDateRange.end);
    return {
      start: isStartValid ? newDateRange.start : null,
      end: isEndValid ? newDateRange.end : null
    };
  }
  /** Handles event on the today button */
  todayButtonHandler() {
    this._activeDate = this._dateAdapter.today();
    if (this._currentView !== 'month') {
      this._currentView = 'month';
    }
    afterNextRender({
      read: () => {
        const currentDateElement = this._elementRef.nativeElement.querySelector('.nx-calendar-body-today');
        if (currentDateElement) {
          currentDateElement.focus();
        }
      }
    }, {
      injector: this._injector
    });
    this.todayButtonClick.emit();
  }
  todayButtonKeydownHandler(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.todayButtonHandler();
    }
  }
  static {
    this.ɵfac = function NxCalendarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxCalendarComponent)(i0.ɵɵdirectiveInject(NxDatepickerIntl), i0.ɵɵdirectiveInject(NxDateAdapter, 8), i0.ɵɵdirectiveInject(i2$1.Directionality, 8), i0.ɵɵdirectiveInject(NX_DATE_FORMATS, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.FocusMonitor), i0.ɵɵdirectiveInject(i1$1.LiveAnnouncer), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxCalendarComponent,
      selectors: [["nx-calendar"]],
      viewQuery: function NxCalendarComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NxMonthViewComponent, 5);
          i0.ɵɵviewQuery(NxYearViewComponent, 5);
          i0.ɵɵviewQuery(NxMultiYearViewComponent, 5);
          i0.ɵɵviewQuery(_c5, 5);
          i0.ɵɵviewQuery(_c6, 5);
          i0.ɵɵviewQuery(_c7, 5);
          i0.ɵɵviewQuery(_c8, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.monthView = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.yearView = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiYearView = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._previousButton = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._nextButton = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._changeViewButton = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._todayButton = _t.first);
        }
      },
      hostAttrs: [1, "nx-calendar"],
      inputs: {
        isRange: [1, "isRange"],
        startAt: "startAt",
        startView: "startView",
        selected: "selected",
        minDate: "minDate",
        maxDate: "maxDate",
        dateFilter: "dateFilter",
        showTodayButton: [2, "showTodayButton", "showTodayButton", booleanAttribute]
      },
      outputs: {
        selectedChange: "selectedChange",
        yearSelected: "yearSelected",
        monthSelected: "monthSelected",
        _userSelection: "_userSelection",
        todayButtonClick: "todayButtonClick"
      },
      exportAs: ["nxCalendar"],
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 19,
      vars: 11,
      consts: [["previousButton", ""], ["nextButton", ""], ["changeViewButton", ""], ["todayButton", ""], [1, "nx-calendar-header"], [1, "nx-calendar-controls"], ["nxPlainButton", "", 1, "nx-calendar-previous-button", 3, "click", "disabled"], ["aria-hidden", "true", 3, "name"], [1, "nx-calendar-period-label"], ["nxPlainButton", "", 1, "nx-calendar-next-button", 3, "click", "disabled"], [1, "nx-calendar-view-controls"], ["nxPlainButton", "", 1, "nx-calendar-change-view-button", 3, "click"], ["cdkMonitorSubtreeFocus", "", "tabindex", "-1", 1, "nx-calendar-content"], [3, "isRange", "activeDate", "selected", "dateFilter", "maxDate", "minDate"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate"], [1, "nx-calendar-footer"], [3, "activeDateChange", "hoverDateChange", "selectedChange", "_userSelection", "isRange", "activeDate", "selected", "dateFilter", "maxDate", "minDate"], [3, "activeDateChange", "monthSelected", "selectedChange", "isRange", "activeDate", "selected", "dateFilter", "maxDate", "minDate"], [3, "activeDateChange", "yearSelected", "selectedChange", "activeDate", "selected", "dateFilter", "maxDate", "minDate"], ["nxPlainButton", "", "type", "button", 3, "click", "keydown", "disabled"]],
      template: function NxCalendarComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "button", 6, 0);
          i0.ɵɵlistener("click", function NxCalendarComponent_Template_button_click_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._previousClicked());
          });
          i0.ɵɵelement(4, "nx-icon", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "span", 8);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "button", 9, 1);
          i0.ɵɵlistener("click", function NxCalendarComponent_Template_button_click_7_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._nextClicked());
          });
          i0.ɵɵelement(9, "nx-icon", 7);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "div", 10)(11, "button", 11, 2);
          i0.ɵɵlistener("click", function NxCalendarComponent_Template_button_click_11_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._changeViewClicked());
          });
          i0.ɵɵtext(13);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(14, "div", 12);
          i0.ɵɵtemplate(15, NxCalendarComponent_Case_15_Template, 1, 6, "nx-month-view", 13)(16, NxCalendarComponent_Case_16_Template, 1, 6, "nx-year-view", 13)(17, NxCalendarComponent_Case_17_Template, 1, 5, "nx-multi-year-view", 14);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(18, NxCalendarComponent_Conditional_18_Template, 4, 3, "div", 15);
        }
        if (rf & 2) {
          let tmp_12_0;
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", !ctx._previousEnabled());
          i0.ɵɵattribute("aria-label", ctx._prevButtonLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("name", ctx._isRtl ? "chevron-right" : "chevron-left");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx._periodButtonText, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", !ctx._nextEnabled());
          i0.ɵɵattribute("aria-label", ctx._nextButtonLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("name", ctx._isRtl ? "chevron-left" : "chevron-right");
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", ctx._periodButtonLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx._periodButtonLabel, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵconditional((tmp_12_0 = ctx._currentView) === "month" ? 15 : tmp_12_0 === "year" ? 16 : tmp_12_0 === "multi-year" ? 17 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.showTodayButton ? 18 : -1);
        }
      },
      dependencies: [NxIconModule, i3.NxIconComponent, CdkMonitorFocus, NxMonthViewComponent, NxYearViewComponent, NxMultiYearViewComponent, NxButtonModule, i6.NxPlainButtonComponent],
      styles: [".nx-calendar-content[_ngcontent-%COMP%]{width:280px;margin:16px auto 0;height:292px}.nx-calendar-previous-button[disabled][_ngcontent-%COMP%], .nx-calendar-next-button[disabled][_ngcontent-%COMP%]{cursor:not-allowed}.nx-calendar-previous-button[disabled][_ngcontent-%COMP%]   nx-icon[_ngcontent-%COMP%], .nx-calendar-next-button[disabled][_ngcontent-%COMP%]   nx-icon[_ngcontent-%COMP%]{color:var(--disabled-01)}.nx-calendar-controls[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding:0 40px}.nx-calendar-period-label[_ngcontent-%COMP%]{font-size:var(--datefield-period-label-font-size);line-height:var(--datefield-period-label-line-height);font-weight:var(--datefield-period-label-font-weight);letter-spacing:var(--datefield-period-label-letter-spacing);color:var(--datefield-period-label-color);text-align:center}.nx-calendar-view-controls[_ngcontent-%COMP%]{text-align:center;height:24px}.nx-calendar-change-view-button[_ngcontent-%COMP%]{margin:8px 0 0}.nx-calendar-change-view-button.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-calendar-previous-button.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-calendar-next-button.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:var(--focus-box-shadow);border-radius:4px}@media screen and (forced-colors: active),(forced-colors: active){.nx-calendar-change-view-button.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-calendar-previous-button.cdk-keyboard-focused[_ngcontent-%COMP%], .nx-calendar-next-button.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}button[_ngcontent-%COMP%]::-moz-focus-inner{border:0}.nx-calendar-footer[_ngcontent-%COMP%]{text-align:center;margin:16px 0 32px}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxCalendarComponent, [{
    type: Component,
    args: [{
      selector: 'nx-calendar',
      host: {
        class: 'nx-calendar'
      },
      exportAs: 'nxCalendar',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NxIconModule, CdkMonitorFocus, NxMonthViewComponent, NxYearViewComponent, NxMultiYearViewComponent, NxButtonModule],
      template: "<div class=\"nx-calendar-header\">\n    <div class=\"nx-calendar-controls\">\n        <button\n            #previousButton\n            nxPlainButton\n            class=\"nx-calendar-previous-button\"\n            [disabled]=\"!_previousEnabled()\"\n            (click)=\"_previousClicked()\"\n            [attr.aria-label]=\"_prevButtonLabel\"\n        >\n            <nx-icon [name]=\"this._isRtl ? 'chevron-right' : 'chevron-left'\" aria-hidden=\"true\"></nx-icon>\n        </button>\n\n        <span class=\"nx-calendar-period-label\"> {{_periodButtonText}} </span>\n\n        <button\n            #nextButton\n            nxPlainButton\n            class=\"nx-calendar-next-button\"\n            [disabled]=\"!_nextEnabled()\"\n            (click)=\"_nextClicked()\"\n            [attr.aria-label]=\"_nextButtonLabel\"\n        >\n            <nx-icon [name]=\"this._isRtl ? 'chevron-left' : 'chevron-right'\" aria-hidden=\"true\"></nx-icon>\n        </button>\n    </div>\n\n    <div class=\"nx-calendar-view-controls\">\n        <button #changeViewButton nxPlainButton class=\"nx-calendar-change-view-button\" (click)=\"_changeViewClicked()\" [attr.aria-label]=\"_periodButtonLabel\">\n            {{_periodButtonLabel}}\n        </button>\n    </div>\n</div>\n\n<div class=\"nx-calendar-content\" cdkMonitorSubtreeFocus tabindex=\"-1\">\n    @switch (_currentView) { @case ('month') {\n    <nx-month-view\n        [isRange]=\"isRange()\"\n        [(activeDate)]=\"_activeDate\"\n        [selected]=\"_selected()\"\n        [dateFilter]=\"dateFilter\"\n        [maxDate]=\"maxDate\"\n        [minDate]=\"minDate\"\n        (hoverDateChange)=\"_hoverDateChange($event)\"\n        (selectedChange)=\"_dateSelected($event!)\"\n        (_userSelection)=\"_userSelected()\"\n    >\n    </nx-month-view>\n    } @case ('year') {\n    <nx-year-view\n        [isRange]=\"isRange()\"\n        [(activeDate)]=\"_activeDate\"\n        [selected]=\"selected\"\n        [dateFilter]=\"dateFilter\"\n        [maxDate]=\"maxDate\"\n        [minDate]=\"minDate\"\n        (monthSelected)=\"_monthSelectedInYearView($event)\"\n        (selectedChange)=\"_goToDateInView($event, 'month')\"\n    >\n    </nx-year-view>\n    } @case ('multi-year') {\n    <nx-multi-year-view\n        [(activeDate)]=\"_activeDate\"\n        [selected]=\"selected\"\n        [dateFilter]=\"dateFilter\"\n        [maxDate]=\"maxDate\"\n        [minDate]=\"minDate\"\n        (yearSelected)=\"_yearSelectedInMultiYearView($event)\"\n        (selectedChange)=\"_goToDateInView($event, 'year')\"\n    >\n    </nx-multi-year-view>\n    } }\n</div>\n@if (showTodayButton) {\n<div class=\"nx-calendar-footer\">\n    <button\n        #todayButton\n        nxPlainButton\n        type=\"button\"\n        (click)=\"todayButtonHandler()\"\n        (keydown)=\"todayButtonKeydownHandler($event)\"\n        [disabled]=\"_disableTodayButton\"\n        [attr.aria-label]=\"_intl.todayButtonAriaLabel\"\n    >\n        {{_intl.todayButtonLabel}}\n    </button>\n</div>\n}\n",
      styles: [".nx-calendar-content{width:280px;margin:16px auto 0;height:292px}.nx-calendar-previous-button[disabled],.nx-calendar-next-button[disabled]{cursor:not-allowed}.nx-calendar-previous-button[disabled] nx-icon,.nx-calendar-next-button[disabled] nx-icon{color:var(--disabled-01)}.nx-calendar-controls{display:flex;justify-content:space-between;align-items:center;padding:0 40px}.nx-calendar-period-label{font-size:var(--datefield-period-label-font-size);line-height:var(--datefield-period-label-line-height);font-weight:var(--datefield-period-label-font-weight);letter-spacing:var(--datefield-period-label-letter-spacing);color:var(--datefield-period-label-color);text-align:center}.nx-calendar-view-controls{text-align:center;height:24px}.nx-calendar-change-view-button{margin:8px 0 0}.nx-calendar-change-view-button.cdk-keyboard-focused,.nx-calendar-previous-button.cdk-keyboard-focused,.nx-calendar-next-button.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow);border-radius:4px}@media screen and (forced-colors: active),(forced-colors: active){.nx-calendar-change-view-button.cdk-keyboard-focused,.nx-calendar-previous-button.cdk-keyboard-focused,.nx-calendar-next-button.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}button::-moz-focus-inner{border:0}.nx-calendar-footer{text-align:center;margin:16px 0 32px}\n"]
    }]
  }], () => [{
    type: NxDatepickerIntl
  }, {
    type: NxDateAdapter,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i2$1.Directionality,
    decorators: [{
      type: Optional
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NX_DATE_FORMATS]
    }]
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i1$1.FocusMonitor
  }, {
    type: i1$1.LiveAnnouncer
  }, {
    type: i0.ElementRef
  }], {
    startAt: [{
      type: Input
    }],
    startView: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    dateFilter: [{
      type: Input
    }],
    showTodayButton: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    selectedChange: [{
      type: Output
    }],
    yearSelected: [{
      type: Output
    }],
    monthSelected: [{
      type: Output
    }],
    _userSelection: [{
      type: Output
    }],
    todayButtonClick: [{
      type: Output
    }],
    monthView: [{
      type: ViewChild,
      args: [NxMonthViewComponent]
    }],
    yearView: [{
      type: ViewChild,
      args: [NxYearViewComponent]
    }],
    multiYearView: [{
      type: ViewChild,
      args: [NxMultiYearViewComponent]
    }],
    _previousButton: [{
      type: ViewChild,
      args: ['previousButton']
    }],
    _nextButton: [{
      type: ViewChild,
      args: ['nextButton']
    }],
    _changeViewButton: [{
      type: ViewChild,
      args: ['changeViewButton']
    }],
    _todayButton: [{
      type: ViewChild,
      args: ['todayButton']
    }]
  });
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Used to generate a unique ID for each datepicker instance. */
let datepickerUid = 0;
/** Injection token that determines the scroll handling while the calendar is open. */
const NX_DATEPICKER_SCROLL_STRATEGY = new InjectionToken('nx-datepicker-scroll-strategy', {
  providedIn: 'root',
  factory: () => {
    const overlay = inject(Overlay);
    return () => overlay.scrollStrategies.reposition();
  }
});
/**
 * @docs-private
 * @deprecated No longer used.
 * @deletion-target 18.0.0
 */
function NX_DATEPICKER_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
  return () => overlay.scrollStrategies.reposition();
}
/**
 * @docs-private
 * @deprecated No longer used.
 * @deletion-target 18.0.0
 */
const NX_DATEPICKER_SCROLL_STRATEGY_PROVIDER = {
  provide: NX_DATEPICKER_SCROLL_STRATEGY,
  deps: [Overlay],
  useFactory: NX_DATEPICKER_SCROLL_STRATEGY_PROVIDER_FACTORY
};
class DatepickerDefaultOptions {
  static {
    this.ɵfac = function DatepickerDefaultOptions_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DatepickerDefaultOptions)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DatepickerDefaultOptions,
      factory: DatepickerDefaultOptions.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerDefaultOptions, [{
    type: Injectable
  }], null, null);
})();
const DATEPICKER_DEFAULT_OPTIONS = new InjectionToken('DATEPICKER_DEFAULT_OPTIONS');
/**
 * Component used as the content for the datepicker dialog and popup. We use this instead of using
 * NxCalendarComponent directly as the content so we can control the initial focus. This also gives us a
 * place to put additional features of the popup that are not part of the calendar itself in the
 * future. (e.g. confirmation buttons).
 * @docs-private
 */
class NxDatepickerContentComponent {
  constructor(_intl, elementRef, _focusMonitor) {
    this._intl = _intl;
    this.elementRef = elementRef;
    this._focusMonitor = _focusMonitor;
    this.isRange = computed(() => this.datepicker.isRange());
    this._afterNextRenderInitial = afterNextRender({
      read: () => {
        this.elementRef.nativeElement.querySelector('.nx-calendar-body-active').focus();
      }
    });
  }
  ngAfterViewInit() {
    this._focusMonitor.monitor(this._closeButton);
  }
  ngOnDestroy() {
    this._focusMonitor.stopMonitoring(this._closeButton);
    this._afterNextRenderInitial.destroy();
  }
  static {
    this.ɵfac = function NxDatepickerContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDatepickerContentComponent)(i0.ɵɵdirectiveInject(NxDatepickerIntl), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.FocusMonitor));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxDatepickerContentComponent,
      selectors: [["nx-datepicker-content"]],
      viewQuery: function NxDatepickerContentComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(NxCalendarComponent, 7);
          i0.ɵɵviewQuery(_c9, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._calendar = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._closeButton = _t.first);
        }
      },
      hostAttrs: [1, "nx-datepicker-content"],
      exportAs: ["nxDatepickerContent"],
      decls: 6,
      vars: 11,
      consts: [["closeButton", ""], ["cdkTrapFocus", "", 1, "nx-calendar-focus-trap"], [1, "nx-datepicker-header"], ["nxPlainButton", "", "type", "button", 1, "nx-datepicker-close", 3, "click"], ["name", "close", "aria-hidden", "true"], [3, "selectedChange", "yearSelected", "monthSelected", "_userSelection", "todayButtonClick", "id", "ngClass", "startAt", "startView", "isRange", "minDate", "maxDate", "dateFilter", "selected", "showTodayButton"]],
      template: function NxDatepickerContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "button", 3, 0);
          i0.ɵɵlistener("click", function NxDatepickerContentComponent_Template_button_click_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.datepicker.close());
          });
          i0.ɵɵelement(4, "nx-icon", 4);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(5, "nx-calendar", 5);
          i0.ɵɵlistener("selectedChange", function NxDatepickerContentComponent_Template_nx_calendar_selectedChange_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.datepicker.select($event));
          })("yearSelected", function NxDatepickerContentComponent_Template_nx_calendar_yearSelected_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.datepicker.selectYear($event));
          })("monthSelected", function NxDatepickerContentComponent_Template_nx_calendar_monthSelected_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.datepicker.selectMonth($event));
          })("_userSelection", function NxDatepickerContentComponent_Template_nx_calendar__userSelection_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.datepicker.close());
          })("todayButtonClick", function NxDatepickerContentComponent_Template_nx_calendar_todayButtonClick_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.datepicker.handleTodayButtonClick());
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", ctx._intl.closeIconLabel || "Close calendar");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("id", ctx.datepicker.id)("ngClass", ctx.datepicker.panelClass)("startAt", ctx.datepicker.startAt)("startView", ctx.datepicker.startView)("isRange", ctx.isRange())("minDate", ctx.datepicker.minDate)("maxDate", ctx.datepicker.maxDate)("dateFilter", ctx.datepicker.dateFilter)("selected", ctx.datepicker.selectedComputed())("showTodayButton", ctx.datepicker.showTodayButton);
        }
      },
      dependencies: [CdkTrapFocus, NxIconModule, i3.NxIconComponent, NxCalendarComponent, NgClass, NxButtonModule, i6.NxPlainButtonComponent],
      styles: ["[_nghost-%COMP%]{background:var(--datefield-panel-background-color);display:flex;flex-flow:column nowrap;box-shadow:var(--shadow-large);border:1px solid var(--datefield-panel-border-color);border-radius:4px}.nx-calendar-focus-trap[_ngcontent-%COMP%]{display:flex;flex-flow:column nowrap;max-height:95vh;overflow-y:auto}.nx-datepicker-header[_ngcontent-%COMP%]{background:var(--datefield-panel-header-background-color);padding:15px 16px 16px;display:flex;height:55px}@media (max-width: 703px){.nx-datepicker-header[_ngcontent-%COMP%]{padding-left:19px;padding-right:19px}}.nx-datepicker-close[_ngcontent-%COMP%]{margin-left:auto}[dir=rtl][_nghost-%COMP%]   .nx-datepicker-close[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-datepicker-close[_ngcontent-%COMP%]{margin-right:auto;margin-left:initial}.nx-datepicker-close.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:var(--focus-box-shadow);border-radius:4px}@media screen and (forced-colors: active),(forced-colors: active){.nx-datepicker-close.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}nx-calendar[_ngcontent-%COMP%]{width:342px;min-height:375px}@media (max-width: 703px){nx-calendar[_ngcontent-%COMP%]{width:302px;min-height:359px}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDatepickerContentComponent, [{
    type: Component,
    args: [{
      selector: 'nx-datepicker-content',
      host: {
        class: 'nx-datepicker-content'
      },
      exportAs: 'nxDatepickerContent',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [CdkTrapFocus, NxIconModule, NxCalendarComponent, NgClass, NxButtonModule],
      template: "<div class=\"nx-calendar-focus-trap\" cdkTrapFocus>\n    <div class=\"nx-datepicker-header\">\n        <button\n            (click)=\"datepicker.close()\"\n            nxPlainButton\n            class=\"nx-datepicker-close\"\n            type=\"button\"\n            #closeButton\n            [attr.aria-label]=\"_intl.closeIconLabel || 'Close calendar'\"\n        >\n            <nx-icon name=\"close\" aria-hidden=\"true\"></nx-icon>\n        </button>\n    </div>\n\n    <nx-calendar\n        [id]=\"datepicker.id\"\n        [ngClass]=\"datepicker.panelClass\"\n        [startAt]=\"datepicker.startAt\"\n        [startView]=\"datepicker.startView\"\n        [isRange]=\"isRange()\"\n        [minDate]=\"datepicker.minDate\"\n        [maxDate]=\"datepicker.maxDate\"\n        [dateFilter]=\"datepicker.dateFilter\"\n        [selected]=\"datepicker.selectedComputed()\"\n        [showTodayButton]=\"datepicker.showTodayButton\"\n        (selectedChange)=\"datepicker.select($event)\"\n        (yearSelected)=\"datepicker.selectYear($event)\"\n        (monthSelected)=\"datepicker.selectMonth($event)\"\n        (_userSelection)=\"datepicker.close()\"\n        (todayButtonClick)=\"datepicker.handleTodayButtonClick()\"\n    >\n    </nx-calendar>\n</div>\n",
      styles: [":host{background:var(--datefield-panel-background-color);display:flex;flex-flow:column nowrap;box-shadow:var(--shadow-large);border:1px solid var(--datefield-panel-border-color);border-radius:4px}.nx-calendar-focus-trap{display:flex;flex-flow:column nowrap;max-height:95vh;overflow-y:auto}.nx-datepicker-header{background:var(--datefield-panel-header-background-color);padding:15px 16px 16px;display:flex;height:55px}@media (max-width: 703px){.nx-datepicker-header{padding-left:19px;padding-right:19px}}.nx-datepicker-close{margin-left:auto}:host-context([dir=rtl]) .nx-datepicker-close{margin-right:auto;margin-left:initial}.nx-datepicker-close.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow);border-radius:4px}@media screen and (forced-colors: active),(forced-colors: active){.nx-datepicker-close.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}nx-calendar{width:342px;min-height:375px}@media (max-width: 703px){nx-calendar{width:302px;min-height:359px}}\n"]
    }]
  }], () => [{
    type: NxDatepickerIntl
  }, {
    type: i0.ElementRef
  }, {
    type: i1$1.FocusMonitor
  }], {
    _calendar: [{
      type: ViewChild,
      args: [NxCalendarComponent, {
        static: true
      }]
    }],
    _closeButton: [{
      type: ViewChild,
      args: ['closeButton']
    }]
  });
})();
/** Component responsible for managing the datepicker popup/dialog. */
class NxDatepickerComponent {
  /** The date to open the calendar initially. */
  set startAt(value) {
    this._startAt = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
  }
  get startAt() {
    // If an explicit startAt is set we start there, otherwise we start at whatever the currently
    // selected value is.
    return this.getStartAtDate();
  }
  /** Whether the calendar is open. */
  set opened(value) {
    value ? this.open() : this.close();
  }
  get opened() {
    return this._opened;
  }
  /**
   * The currently selected date.
   * @docs-private
   */
  set selected(value) {
    this._selected.set(value);
  }
  get selected() {
    return this._selected();
  }
  /**
   * The minimum selectable date.
   * @docs-private
   */
  get minDate() {
    return this._datepickerInput?.min || this._datepickerInputStartDate?.min || null;
  }
  /**
   * The maximum selectable date.
   * @docs-private
   */
  get maxDate() {
    return this._datepickerInput?.max || this._datepickerInputEndDate?.max || null;
  }
  set dateFilter(value) {
    this._dateFilter = value;
  }
  get dateFilter() {
    return this._datepickerInput?._dateFilter || this._dateFilter;
  }
  constructor(_overlay, _viewContainerRef, _defaultScrollStrategyFactory, _dateAdapter, _dir, _document) {
    this._overlay = _overlay;
    this._viewContainerRef = _viewContainerRef;
    this._defaultScrollStrategyFactory = _defaultScrollStrategyFactory;
    this._dir = _dir;
    this._document = _document;
    this._injector = inject(Injector);
    this.isRange = computed(() => this.rangeMode());
    /** The view that the calendar should start in. */
    this.startView = 'month';
    /** Determines whether the today button is displayed in the calendar. */
    this.showTodayButton = false;
    /**
     * Whether the datepicker pop-up should be disabled.
     * The datepicker is also disabled if the belonging input is readonly.
     */
    this.disabledInput = model(undefined, {
      alias: 'disabled'
    });
    this.disabled = computed(() => {
      if (this.disabledInput() !== undefined) {
        return this.disabledInput();
      }
      return this._datepickerInput?.readonly() || this._datepickerInputStartDate?.readonly() || false;
    });
    /**
     * Event emitter for selection changes.
     *
     * Emits <D> if the datepicker is in single date selection mode.
     * Emits DateRange<D> if the datepicker is in range selection mode.
     * Never emits any other type. `any` is used here to avoid breaking changes and will be removed in Angular NDBX v20 major release.
     */
    this.selectedChanged = new EventEmitter();
    /**
     * Emits selected year in multiyear view.
     * This doesn't imply a change on the selected date.
     */
    this.yearSelected = new EventEmitter();
    /**
     * Emits selected month in year view.
     * This doesn't imply a change on the selected date.
     */
    this.monthSelected = new EventEmitter();
    /** Emits when the datepicker has been opened. */
    this.openedStream = new EventEmitter();
    /** Emits when the datepicker has been closed. */
    this.closedStream = new EventEmitter();
    /**
     * Emits when the Today button is clicked.
     * This doesn't imply a change on the selected date.
     */
    this.todayButtonClick = new EventEmitter();
    this._opened = false;
    /**
     * The id for the datepicker calendar.
     * @docs-private
     */
    this.id = `nx-datepicker-${datepickerUid++}`;
    // private _validSelected: D | DateRange<D> | null = null;
    this._selected = signal(null);
    this.selectedComputed = computed(() => this._selected());
    /** The element that was focused before the datepicker was opened. */
    this._focusedElementBeforeOpen = null;
    /** Strategy factory that will be used to handle scrolling while the datepicker panel is open. */
    this._scrollStrategyFactory = this._defaultScrollStrategyFactory;
    /** Emits when the datepicker is disabled. */
    this._disabledChange = new Subject();
    this._destroyed = new Subject();
    this.rangeMode = input(false);
    if (!_dateAdapter) {
      throw createMissingDateImplError('DateAdapter');
    }
    this._dateAdapter = _dateAdapter;
    this._dir?.change.pipe(takeUntil(this._destroyed)).subscribe(() => {
      this.close();
      this._destroyPopup();
    });
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this.close();
    this._disabledChange.complete();
    if (this._popupRef) {
      this._popupRef.dispose();
      this._popupComponentRef = null;
    }
  }
  /**
   * Selects the given date.
   * @docs-private
   */
  select(date) {
    const oldValue = this._selected();
    this._selected.set(date);
    if (this.isRange() || !this.isRange() && !this._dateAdapter.sameDate(oldValue, this.selected)) {
      this.selectedChanged.emit(this._selected());
    }
  }
  /**
   * Emits the selected year in multiyear view.
   * @docs-private
   */
  selectYear(normalizedYear) {
    this.yearSelected.emit(normalizedYear || undefined);
  }
  /**
   * Emits selected month in year view.
   * @docs-private
   */
  selectMonth(normalizedMonth) {
    this.monthSelected.emit(normalizedMonth || undefined);
  }
  /**
   * Register an input with this datepicker.
   * @param input The datepicker input to register with this datepicker.
   * @docs-private
   */
  registerInput(input, inputDateMode = 'single') {
    if (this._datepickerInput && !this.isRange()) {
      throw Error('A NxDatepicker can only be associated with a single input.');
    }
    if (inputDateMode === 'start') {
      this._datepickerInputStartDate = input;
      this._datepickerInputStartDate._valueChange.pipe(takeUntil(this._destroyed)).subscribe(value => {
        // this._selected.set((value as DateRange<D>)?.start)
        this._selected.set({
          start: value,
          end: this._selected()?.end
        });
      });
    } else if (inputDateMode === 'end') {
      this._datepickerInputEndDate = input;
      this._datepickerInputEndDate._valueChange.pipe(takeUntil(this._destroyed)).subscribe(value => {
        // this._selected.set((value as DateRange<D>)?.end)
        this._selected.set({
          start: this._selected()?.start,
          end: value
        });
      });
    } else {
      this._datepickerInput = input;
      this._datepickerInput._valueChange.pipe(takeUntil(this._destroyed)).subscribe(value => {
        this._selected.set(value);
      });
    }
  }
  /**
   * Register an input toggle with this datepicker.
   * @docs-private
   */
  registerToggle(toggle) {
    if (this._toggleButton) {
      throw Error('A NxDatepicker can only be associated with a single toggle button.');
    }
    this._toggleButton = toggle;
  }
  /**
   * Open the calendar.
   * @docs-private
   */
  open() {
    if (this._opened || this.disabled()) {
      return;
    }
    if (!this.isRange() && !this._datepickerInput || this.isRange() && (!this._datepickerInputStartDate || !this._datepickerInputEndDate)) {
      throw Error('Attempted to open an NxDatepicker with no associated input.');
    }
    if (this._document) {
      this._focusedElementBeforeOpen = this._document.activeElement;
    }
    this._openAsPopup();
    this._opened = true;
    this.openedStream.emit();
  }
  /**
   * Close the calendar.
   * @docs-private
   */
  close() {
    const inRangeModeAndOnlyStartDateSelected = this.isRange() && this.selected?.start && !this.selected?.end;
    if (inRangeModeAndOnlyStartDateSelected) {
      this.select({
        start: this.selected?.start,
        end: this.selected?.start
      });
    }
    if (!this._opened) {
      return;
    }
    if (this._popupRef?.hasAttached()) {
      this._popupRef.detach();
    }
    if (this._calendarPortal?.isAttached) {
      this._calendarPortal.detach();
    }
    const completeClose = () => {
      // The `_opened` could've been reset already if
      // we got two events in quick succession.
      if (this._opened) {
        this._opened = false;
        this.closedStream.emit();
        this._focusedElementBeforeOpen = null;
      }
    };
    if (this._focusedElementBeforeOpen && typeof this._focusedElementBeforeOpen.focus === 'function') {
      // Because IE moves focus asynchronously, we can't count on it being restored before we've
      // marked the datepicker as closed. If the event fires out of sequence and the element that
      // we're refocusing opens the datepicker on focus, the user could be stuck with not being
      // able to close the calendar at all. We work around it by making the logic, that marks
      // the datepicker as closed, async as well.
      this._focusedElementBeforeOpen.focus();
      setTimeout(completeClose);
    } else {
      completeClose();
    }
    // if the datepicker toggle button is not focusable, focus the associated input.
    if (this._toggleButton && this._toggleButton.tabindex < 0) {
      this._datepickerInput._focus();
    }
  }
  /** Open the calendar as a popup. */
  _openAsPopup() {
    if (!this._calendarPortal) {
      this._calendarPortal = new ComponentPortal(NxDatepickerContentComponent, this._viewContainerRef);
    }
    if (!this._popupRef) {
      this._createPopup();
    }
    if (!this._popupRef.hasAttached()) {
      this._popupComponentRef = this._popupRef.attach(this._calendarPortal);
      this._popupComponentRef.instance.datepicker = this;
      afterNextRender({
        write: () => {
          this._popupRef.updatePosition();
        }
      }, {
        injector: this._injector
      });
    }
  }
  /** Create the popup. */
  _createPopup() {
    const overlayConfig = new OverlayConfig({
      positionStrategy: this._createPopupPositionStrategy(),
      hasBackdrop: true,
      backdropClass: 'nx-overlay-transparent-backdrop',
      direction: this._dir?.value || 'ltr',
      scrollStrategy: this._scrollStrategyFactory(),
      panelClass: 'nx-datepicker-popup'
    });
    this._popupRef = this._overlay.create(overlayConfig);
    merge(this._popupRef.backdropClick(), this._popupRef.keydownEvents().pipe(filter(event => event.keyCode === ESCAPE))).pipe(takeUntil(this._destroyed)).subscribe(() => this.close());
  }
  /** Destroy popup */
  _destroyPopup() {
    if (this._popupRef) {
      this._popupRef = null;
      this._popupComponentRef = null;
      this._calendarPortal = null;
    }
  }
  /** Create the popup PositionStrategy. */
  _createPopupPositionStrategy() {
    const dateInputPositionAnchor = this.isRange() ? this._datepickerInputEndDate : this._datepickerInput;
    return this._overlay.position().flexibleConnectedTo(dateInputPositionAnchor.getConnectedOverlayOrigin()).withTransformOriginOn('.nx-datepicker-content').withFlexibleDimensions(false).withViewportMargin(8).withLockedPosition().withPositions([{
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top'
    }, {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom'
    }, {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top'
    }, {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom'
    }]);
  }
  /**
   * @param obj The object to check.
   * @returns The given object if it is both a date instance and valid, otherwise null.
   */
  _getValidDateOrNull(obj) {
    return this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj) ? obj : null;
  }
  getStartAtDate() {
    if (this._startAt) {
      return this._startAt;
    }
    if (!this.isRange()) {
      return this._datepickerInput.value;
    }
    return this._datepickerInputStartDate?.value;
  }
  handleTodayButtonClick() {
    this.todayButtonClick.emit();
  }
  static {
    this.ɵfac = function NxDatepickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDatepickerComponent)(i0.ɵɵdirectiveInject(i5$1.Overlay), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(NX_DATEPICKER_SCROLL_STRATEGY), i0.ɵɵdirectiveInject(NxDateAdapter, 8), i0.ɵɵdirectiveInject(i2$1.Directionality, 8), i0.ɵɵdirectiveInject(DOCUMENT, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxDatepickerComponent,
      selectors: [["nx-datepicker"]],
      inputs: {
        startAt: "startAt",
        startView: "startView",
        showTodayButton: "showTodayButton",
        disabledInput: [1, "disabled", "disabledInput"],
        panelClass: "panelClass",
        opened: "opened",
        rangeMode: [1, "rangeMode"]
      },
      outputs: {
        disabledInput: "disabledChange",
        yearSelected: "yearSelected",
        monthSelected: "monthSelected",
        openedStream: "opened",
        closedStream: "closed",
        todayButtonClick: "todayButtonClick"
      },
      exportAs: ["nxDatepicker"],
      decls: 0,
      vars: 0,
      template: function NxDatepickerComponent_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDatepickerComponent, [{
    type: Component,
    args: [{
      selector: 'nx-datepicker',
      template: '',
      exportAs: 'nxDatepicker',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true
    }]
  }], () => [{
    type: i5$1.Overlay
  }, {
    type: i0.ViewContainerRef
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [NX_DATEPICKER_SCROLL_STRATEGY]
    }]
  }, {
    type: NxDateAdapter,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i2$1.Directionality,
    decorators: [{
      type: Optional
    }]
  }, {
    type: Document,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [DOCUMENT]
    }]
  }], {
    startAt: [{
      type: Input
    }],
    startView: [{
      type: Input
    }],
    showTodayButton: [{
      type: Input
    }],
    yearSelected: [{
      type: Output
    }],
    monthSelected: [{
      type: Output
    }],
    panelClass: [{
      type: Input
    }],
    openedStream: [{
      type: Output,
      args: ['opened']
    }],
    closedStream: [{
      type: Output,
      args: ['closed']
    }],
    todayButtonClick: [{
      type: Output
    }],
    opened: [{
      type: Input
    }]
  });
})();

/** Can be used to override the icon of a `nxDatepickerToggle`. */
class NxDatepickerToggleIconComponent {
  static {
    this.ɵfac = function NxDatepickerToggleIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDatepickerToggleIconComponent)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxDatepickerToggleIconComponent,
      selectors: [["", "nxDatepickerToggleIcon", ""]]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDatepickerToggleIconComponent, [{
    type: Directive,
    args: [{
      selector: '[nxDatepickerToggleIcon]',
      standalone: true
    }]
  }], null, null);
})();
class NxDatepickerToggleComponent {
  /** Datepicker instance that the button will toggle. */
  set datepicker(value) {
    this.registerDatepicker(value);
  }
  get datepicker() {
    return this._datepicker;
  }
  /** Sets the tabindex for the toggle button. Default: 0. */
  set tabindex(value) {
    const newValue = coerceNumberProperty(value);
    if (this._tabindex !== newValue) {
      this._tabindex = newValue;
    }
  }
  get tabindex() {
    if (this._tabindex !== undefined) {
      return this._tabindex;
    }
    if (this._defaultOptions?.toggleIconTabindex !== undefined) {
      return this._defaultOptions.toggleIconTabindex;
    }
    return 0;
  }
  constructor(_intl, _cdr, _defaultOptions, _focusMonitor) {
    this._intl = _intl;
    this._cdr = _cdr;
    this._defaultOptions = _defaultOptions;
    this._focusMonitor = _focusMonitor;
    this._stateChanges = Subscription.EMPTY;
    /** Whether the toggle button is disabled. */
    this.disabledInput = model(undefined, {
      alias: 'disabled'
    });
    this.disabled = computed(() => {
      if (this.disabledInput() !== undefined) {
        return this.disabledInput();
      }
      return this.datepicker.disabled() || false;
    });
    this._destroyed = new Subject();
    if (this._defaultOptions?.changes) {
      this._defaultOptions.changes.pipe(takeUntil(this._destroyed)).subscribe(() => {
        this._cdr.markForCheck();
      });
    }
  }
  ngAfterViewInit() {
    this._focusMonitor.monitor(this._toggleButton);
  }
  ngOnChanges(changes) {
    if (changes.datepicker) {
      this._watchStateChanges();
    }
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this._stateChanges.unsubscribe();
    this._focusMonitor.stopMonitoring(this._toggleButton);
  }
  ngAfterContentInit() {
    this._watchStateChanges();
  }
  _open(event) {
    if (this.datepicker && !this.disabled()) {
      this.datepicker.open();
      event.stopPropagation();
    }
  }
  registerDatepicker(value) {
    if (value) {
      this._datepicker = value;
      this._datepicker.registerToggle(this);
    }
  }
  _watchStateChanges() {
    const datepickerDisabled = this.datepicker ? this.datepicker._disabledChange.asObservable() : of();
    const inputDisabled = this.datepicker?._datepickerInput ? this.datepicker._datepickerInput._disabledChange.asObservable() : of();
    const datepickerToggled = this.datepicker ? merge(this.datepicker.openedStream, this.datepicker.closedStream) : of();
    this._stateChanges.unsubscribe();
    this._stateChanges = merge(this._intl.changes, datepickerDisabled, inputDisabled, datepickerToggled).pipe(takeUntil(this._destroyed)).subscribe(() => this._cdr.markForCheck());
  }
  static {
    this.ɵfac = function NxDatepickerToggleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDatepickerToggleComponent)(i0.ɵɵdirectiveInject(NxDatepickerIntl), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DATEPICKER_DEFAULT_OPTIONS, 8), i0.ɵɵdirectiveInject(i1$1.FocusMonitor));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxDatepickerToggleComponent,
      selectors: [["nx-datepicker-toggle"]],
      contentQueries: function NxDatepickerToggleComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NxDatepickerToggleIconComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._customIcon = _t.first);
        }
      },
      viewQuery: function NxDatepickerToggleComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c10, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toggleButton = _t.first);
        }
      },
      hostAttrs: [1, "nx-datepicker-toggle"],
      hostVars: 4,
      hostBindings: function NxDatepickerToggleComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("nx-datepicker-toggle-active", ctx.datepicker && ctx.datepicker.opened)("nx-datepicker-toggle--disabled", ctx.disabled());
        }
      },
      inputs: {
        datepicker: [0, "for", "datepicker"],
        disabledInput: [1, "disabled", "disabledInput"],
        tabindex: "tabindex"
      },
      outputs: {
        disabledInput: "disabledChange"
      },
      exportAs: ["nxDatepickerToggle"],
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c12,
      decls: 4,
      vars: 4,
      consts: [["toggleButton", ""], ["type", "button", 1, "nx-datepicker-toggle-button", 3, "click", "tabindex", "disabled"], ["name", "calendar", "aria-hidden", "true"]],
      template: function NxDatepickerToggleComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c11);
          i0.ɵɵelementStart(0, "button", 1, 0);
          i0.ɵɵlistener("click", function NxDatepickerToggleComponent_Template_button_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._open($event));
          });
          i0.ɵɵtemplate(2, NxDatepickerToggleComponent_Conditional_2_Template, 1, 0, "nx-icon", 2);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("tabindex", ctx.tabindex)("disabled", ctx.disabled());
          i0.ɵɵattribute("aria-label", ctx._intl.openCalendarLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx._customIcon ? 2 : -1);
        }
      },
      dependencies: [NxIconModule, i3.NxIconComponent],
      styles: ["[_nghost-%COMP%]{position:relative;display:flex}[_nghost-%COMP%]:active{outline:none}[_nghost-%COMP%]:hover{color:var(--hover-primary)}.nx-datepicker-toggle-button[_ngcontent-%COMP%]{border:none;background-color:transparent;color:inherit;outline:none;cursor:pointer;padding:0;margin:0}.nx-datepicker-toggle-button[_ngcontent-%COMP%]::-moz-focus-inner{border:0}@media screen and (forced-colors: active){.nx-datepicker-toggle-button[_ngcontent-%COMP%]{color:ButtonText}}.default-icon[_ngcontent-%COMP%]{display:block;height:var(--datefield-toggle-icon-size);width:var(--datefield-toggle-icon-size)}.nx-datepicker-toggle--disabled[_nghost-%COMP%]   .nx-datepicker-toggle-button[_ngcontent-%COMP%]{cursor:not-allowed}@media screen and (forced-colors: active){.nx-datepicker-toggle--disabled[_nghost-%COMP%]   .nx-datepicker-toggle-button[_ngcontent-%COMP%]{color:GrayText}}.nx-datepicker-toggle-button.cdk-keyboard-focused[_ngcontent-%COMP%]{border-radius:4px;box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.nx-datepicker-toggle-button.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDatepickerToggleComponent, [{
    type: Component,
    args: [{
      selector: 'nx-datepicker-toggle',
      host: {
        class: 'nx-datepicker-toggle',
        '[class.nx-datepicker-toggle-active]': 'datepicker && datepicker.opened',
        '[class.nx-datepicker-toggle--disabled]': 'disabled()'
      },
      exportAs: 'nxDatepickerToggle',
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [NxIconModule],
      template: "<button\n    #toggleButton\n    class=\"nx-datepicker-toggle-button\"\n    [tabindex]=\"tabindex\"\n    type=\"button\"\n    [attr.aria-label]=\"_intl.openCalendarLabel\"\n    [disabled]=\"disabled()\"\n    (click)=\"_open($event)\"\n>\n    @if (!_customIcon) {\n    <nx-icon name=\"calendar\" aria-hidden=\"true\"></nx-icon>\n    }\n\n    <ng-content select=\"[nxDatepickerToggleIcon]\"></ng-content>\n</button>\n",
      styles: [":host{position:relative;display:flex}:host:active{outline:none}:host:hover{color:var(--hover-primary)}.nx-datepicker-toggle-button{border:none;background-color:transparent;color:inherit;outline:none;cursor:pointer;padding:0;margin:0}.nx-datepicker-toggle-button::-moz-focus-inner{border:0}@media screen and (forced-colors: active){.nx-datepicker-toggle-button{color:ButtonText}}.default-icon{display:block;height:var(--datefield-toggle-icon-size);width:var(--datefield-toggle-icon-size)}:host(.nx-datepicker-toggle--disabled) .nx-datepicker-toggle-button{cursor:not-allowed}@media screen and (forced-colors: active){:host(.nx-datepicker-toggle--disabled) .nx-datepicker-toggle-button{color:GrayText}}.nx-datepicker-toggle-button.cdk-keyboard-focused{border-radius:4px;box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.nx-datepicker-toggle-button.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}\n"]
    }]
  }], () => [{
    type: NxDatepickerIntl
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: DatepickerDefaultOptions,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [DATEPICKER_DEFAULT_OPTIONS]
    }]
  }, {
    type: i1$1.FocusMonitor
  }], {
    _customIcon: [{
      type: ContentChild,
      args: [NxDatepickerToggleIconComponent]
    }],
    _toggleButton: [{
      type: ViewChild,
      args: ['toggleButton']
    }],
    datepicker: [{
      type: Input,
      args: ['for']
    }],
    tabindex: [{
      type: Input
    }]
  });
})();
class NxDatefieldModule {
  static {
    this.ɵfac = function NxDatefieldModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxDatefieldModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NxDatefieldModule,
      imports: [CommonModule, OverlayModule, A11yModule, NxIconModule, NxDatefieldDirective, NxDatepickerComponent, NxDatepickerToggleIconComponent, NxDatepickerToggleComponent, NxDatepickerContentComponent, NxCalendarComponent, NxCalendarBodyComponent, NxMonthViewComponent, NxMultiYearViewComponent, NxYearViewComponent],
      exports: [NxDatefieldDirective, NxDatepickerComponent, NxDatepickerToggleIconComponent, NxDatepickerToggleComponent, NxCalendarComponent, NxCalendarBodyComponent, NxMonthViewComponent, NxMultiYearViewComponent, NxYearViewComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [
      // Provide our NX_DATE_LOCALE to determine the current language
      NX_DATE_LOCALE_PROVIDER],
      imports: [CommonModule, OverlayModule, A11yModule, NxIconModule, NxDatepickerToggleComponent, NxDatepickerContentComponent, NxCalendarComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxDatefieldModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, OverlayModule, A11yModule, NxIconModule, NxDatefieldDirective, NxDatepickerComponent, NxDatepickerToggleIconComponent, NxDatepickerToggleComponent, NxDatepickerContentComponent, NxCalendarComponent, NxCalendarBodyComponent, NxMonthViewComponent, NxMultiYearViewComponent, NxYearViewComponent],
      providers: [
      // Provide our NX_DATE_LOCALE to determine the current language
      NX_DATE_LOCALE_PROVIDER],
      exports: [NxDatefieldDirective, NxDatepickerComponent, NxDatepickerToggleIconComponent, NxDatepickerToggleComponent, NxCalendarComponent, NxCalendarBodyComponent, NxMonthViewComponent, NxMultiYearViewComponent, NxYearViewComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DATEPICKER_DEFAULT_OPTIONS, DateRange, DatepickerDefaultOptions, NX_DATEFIELD_VALIDATORS, NX_DATEFIELD_VALUE_ACCESSOR, NX_DATEPICKER_SCROLL_STRATEGY, NX_DATEPICKER_SCROLL_STRATEGY_PROVIDER, NX_DATEPICKER_SCROLL_STRATEGY_PROVIDER_FACTORY, NX_DATE_FORMATS, NX_DATE_LOCALE, NX_DATE_LOCALE_PROVIDER, NX_DATE_STRICT, NX_NATIVE_DATE_FORMATS, NativeDateModule, NxCalendarBodyComponent, NxCalendarCell, NxCalendarComponent, NxDateAdapter, NxDateRangeComponent, NxDateRangeIntl, NxDateRangeValidators, NxDateValidators, NxDatefieldDirective, NxDatefieldModule, NxDatepickerComponent, NxDatepickerContentComponent, NxDatepickerInputEvent, NxDatepickerIntl, NxDatepickerToggleComponent, NxDatepickerToggleIconComponent, NxMonthViewComponent, NxMultiYearViewComponent, NxNativeDateAdapter, NxNativeDateModule, NxYearViewComponent, yearsPerPage$1 as yearsPerPage, yearsPerRow };
